import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild, ViewContainerRef, QueryList, ViewChildren, ChangeDetectorRef, SimpleChanges, Injector, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { Subscription, BehaviorSubject, take, forkJoin, of, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SmartModalService, ModalSize } from '../../services/smart-modal.service';
import { DynamicPopUpComponent } from './dynamic-pop-up/dynamic-pop-up.component';
import { DialogService } from '../dialog/dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { CommunicationService } from '../../services/communication.service';
import { StorageService } from '../../shared/services/storage.service';
import { AppService } from '../../shared/services/app.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { UtilService } from '../../services/util.service';
import { LoaderService } from '../../services/loader.service';
import { DownloadPopupComponent } from './download-popup/download-popup.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { PopUpOverGridWithControlsComponent } from '../dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { PopupFormComponent } from '../popupform/popupform.component';
import { ManageFilterComponent } from './manage-filter/manage-filter.component';
import { ModalService } from '../../services/modal.service';
import { DateRangeConfig } from '../daterangepicker/dateconfig.service';
import { ShowPdfComponent } from '../file-uploader/show-pdf/show-pdf.component';
import { AsideBarService } from '../../services/asideBar.service';
import { MultipleFormComponent } from '../../multiple-form/multiple-form.component';
import { PreferenceService } from '../../shared/services/preference.service';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';
import { CommonService } from '../../services/common.service';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import get_ from 'lodash-es/get';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { MapValuePipe } from '../../pipes/map-value.pipe';
import { JsonViewerComponent } from '../viewer/json-viewer/json-viewer.component';
import { HtmlViewerComponent } from '../viewer/html-viewer/html-viewer.component';
import { AuditLogComponent } from '../audit-log/audit-log.component';
import moment from 'proxies/dayjs';
import { RuleEngineService } from '../../shared/services/ruleengine.service';
import { QrCodeGeneratorComponent } from '../qr-code-reader/qr-code-generator/qr-code-generator.component';
import { ImageViewerComponent } from '../viewer/image-viewer/image-viewer.component';
import { PrintPopupComponent } from './print-popup/print-popup.component';
import { TranslateService } from '../../services/translate.service';

declare var jQuery: any;
@Component({
    selector: 'dhs-data-grid',
    templateUrl: './data-grid.component.html',
    styleUrls: ['./data-grid.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({})),
            transition('void => *', [
                animate(100, keyframes([
                    style({ opacity: 0, offset: 0 }),
                    style({ opacity: 1, offset: 1 })
                ]))
            ])
        ])
    ],
    standalone: false
})
export class DataGridComponent implements OnInit, OnDestroy {
    activeContextRow: number = -1;
    private sub: Subscription = new Subscription();
    translationCache: Record<string, string> = {};
    loadingTranslations: Set<string> = new Set();
    @ViewChild("complexSearch") complexSearchRef: any;
    public _allowedContextMenu: any = {};
    @ViewChild("contextMenu") contextMenu: any;
    @Input() filterFieldGroup: any;
    public filterFormGroup: any = false;
    @Output() bannerRefreshClick = new EventEmitter<any>();
    public filterFormMapping: any = false;
    @Input() customButtons: any = false;
    // #getElementHeight
    @ViewChild('getElementHeight') cardElem: ElementRef;
    //@Input() viewAll: boolean = true;   // for showing the all checkbox selected,// should be part of config
    //@Input() hideSearchBox: boolean = false; // should be part of config
    // @Input() hideResult: boolean = false; // should be part of config
    // @Input() allowPagination: boolean = true; // should be part of config

    //@Input() minWidth: string; // should be part of config. Its obsolete
    @ViewChild('kxFilter') kxFilter: ElementRef;
    @Input() config: any;
    masterUploadList: any[] = [];
    @Input() bulkActionsConfig: any = false; // for providing config to bulk action
    //@Input() registerButton: boolean = false; // Not used
    //@Input() showEyes: boolean = true; //not used anywhere
    //@Input() url: string;
    //@Input() systemType: string;
    //@Input() message: string;
    @Input() fields: Array<any>;
    @Input() cardHeaders: any;
    @Input() legend: any;
    @Input() extra_buttons: any;
    @Input() cardResourceMbl: any;
    limitErrorShown = false;
    //@Input() refresh: Observable<any>;
    //@Input() filterRefresh: Observable<any>;

    //@Input() allSelected: Observable<any>; // should be part of config
    @Input() plurals: Array<any> = ['item', 'items'];
    @Input() rowClick: any; //for providing what to do when row is clicked
    //@Input() templates: { [key: string]: TemplateRef<ElementRef> } = {};
    @Output() actionClicked = new EventEmitter();
    @Output() configValues = new EventEmitter<any>();
    @Output() bulkActionClicked = new EventEmitter<BulkActionClickEvent>();
    @Output() editClick: EventEmitter<any> = new EventEmitter(); //Not used
    //@Output() deleteClick: EventEmitter<any> = new EventEmitter();  //Not used
    @Output() onLimitChange: EventEmitter<any> = new EventEmitter();
    @Output() editEllipseClick: EventEmitter<any> = new EventEmitter();
    @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
    @Output() onPageChanges: EventEmitter<any> = new EventEmitter();
    @Output() onSortChanges: EventEmitter<any> = new EventEmitter();
    //@Output() patientRegistration: EventEmitter<any> = new EventEmitter();
    @Output() bindGrid: EventEmitter<any> = new EventEmitter();
    @Output() checkBoxDataEmit: EventEmitter<any> = new EventEmitter();
    @Output() emitCustomLink: EventEmitter<any> = new EventEmitter();
    @Output() checkboxaction: EventEmitter<any> = new EventEmitter();
    @ViewChild('selectedAllCheckbox') selectedAllCheckbox: any;
    @ViewChild('SEARCHKEY') SEARCHKEY: ElementRef;
    @Output() gridPopupClicked = new EventEmitter<any>();
    @ViewChildren('customComponent', { read: ViewContainerRef }) customComponent: QueryList<ViewContainerRef>;
    formBlock: any = false;
    isLoading = false;
    profileImg: any;
    page = 1;
    limit = 10;
    filter = '';
    items: Array<any> = [];
    sourceItems: Array<any> = [];
    isChecked: number = 0;
    toggle: boolean = false;
    // getClass: string = "test";
    private _data = new BehaviorSubject<any>({});
    addTableClass: boolean = false;
    width: number;
    isCountClick: boolean = false;
    cloneItems: any;
    noActionRequired: boolean = true;
    configBasedCapability: boolean = false;
    private tableExpandedOnce: boolean = false;
    decoratorInstance: any;
    @Input()
    set data(value) {
        this._data.next(value);
    };

    get data() {
        return this._data.getValue();
    }

    itemsCount: number;

    currentSort: Map<string, number> = new Map();

    private columns: any = {};
    selectedItems: any[] = [];
    selectedIndices: boolean[];
    selectedCount = 0;
    evaluatedData: any;
    enableCheckedItems: any[] = [];
    _cardFields: any;
    capabilityField: any;
    //private sub: Subscription;
    private subSelected: Subscription;
    public _currentResource: string = "";
    // private amberDictionaries = {};
    // private showActionSpan = false;
    // showEmptyMessage = false;
    flag: boolean;
    show_filter: boolean = false;
    tableInitalized: boolean = false;
    autorefresh: any = {};
    defaultDynamicfilter: any;
    showPrint: boolean = false;
    showPrintMobile: boolean = false; // printActions dropdown in the small-screen quick-actions panel
    showDownload: boolean = false;
    showMoreQuickActions: boolean = false; // is the overflow (⋮) menu's dropdown open
    tooManyQuickActions: boolean = false; // true once the toolbar has >7 action icons - collapses Help/Configure Grid/Logs into the (⋮) overflow menu
    cardTopView: any;
    gridPrintFlag: boolean = false;
    archiveMessage = "Data is ready to download.";
    singleFieldSelection: any;
    copiedFieldId: any = null;
    isItemsExist = true;
    isDirectBookingEnabled = false;
    constructor(
        public smartModalService: SmartModalService,
        public dialogService: DialogService,
        public modalService: ModalService,
        public baseService: BaseService,
        public appService: AppService,
        public alerts: AlertsService,
        public route: ActivatedRoute,
        public router: Router,
        public storageService: StorageService,
        public rolePermissionService: RolePermissionService,
        public elementRef: ElementRef,
        public communicationService: CommunicationService,
        public loader: LoaderService,
        public utilService: UtilService,
        public preferenceService: PreferenceService,
        public mapValuePipe: MapValuePipe,
        public changeDetectorRef?: ChangeDetectorRef,
        public asideBarService?: AsideBarService,
        public commonService?: CommonService,
        public DomSanitizer?: DomSanitizer,
        public ruleEngineService?: RuleEngineService,
        public injector?: Injector,
        public translateService?: TranslateService
        //   private ngZone?: NgZone,
    ) {
    }
    displayFilter(event?) {
        //this.show_filter = !this.show_filter;
        if (event != undefined && event.target.className.indexOf('ng-month-year') > -1) {
            return;
        }
        // for preventing filter to close in case of advance search selecteion
        if (event != undefined && event.target != undefined && this._currentResource != undefined && this._currentResource != '' && document.getElementById('ui_defaultAdvSearch')) {
            return;
        }
        if (event != undefined && event.target.className.indexOf('fa-times-circle') > -1) {
            this.filterFieldGroup.blocks.list.filter.default_open = true;
            this.config['filterOpenStatus'] = this.filterFieldGroup.blocks.list.filter.default_open;
        } else if (this.filterFieldGroup.blocks.list.filter.hasOwnProperty('default_open')) {
            this.filterFieldGroup.blocks.list.filter.default_open = !this.filterFieldGroup.blocks.list.filter.default_open;
            this.config['filterOpenStatus'] = this.filterFieldGroup.blocks.list.filter.default_open;
        }
        if (this.filterFieldGroup.blocks.list.filter.default_open == false)
            this.config.canBeTriggered = false
        else {
            setTimeout(() => {
                this.config.canBeTriggered = true
            })
        }
        setTimeout(() => {
            if (this.changeDetectorRef && !this.config.stopChangeProp) {
                this.changeDetectorRef.detectChanges();
                this.config.stopChangeProp = false;
            }
        });
    }

    setAccountAwareFacilityId(data) {
        if (this.config.accountAware != undefined && this.config.accountAware.grid_key != undefined && data[this.config.accountAware.grid_key] != undefined && data[this.config.accountAware.grid_key]) {
            this.baseService.setAccountAwareFacilityID(data[this.config.accountAware.grid_key]);
        }
    }

    /**
     * Return the original source item by index (fallback) or return given item.
     * @param index optional index into sourceItems
     * @param item fallback item
     */
    private getSourceItem(index?: number, item?: any) {
        if (index != undefined && this.sourceItems && this.sourceItems[index] != undefined) {
            // Fallback to index-based lookup if ID not found
            return this.sourceItems[index];
        }
        return item;
    }

    /**
     * Resolve a value to its original object from `sourceItems`.
     * Supports arrays, bulk-key matching (if configured) and id matching.
     * @param val value or array to resolve
     * @returns matched source item(s) or original value if no match
     */
    private getOriginalValue(val: any) {
        if (Array.isArray(val)) {
            return val.map(item => this.getOriginalValue(item));
        }

        if (!val || !this.sourceItems || this.sourceItems.length === 0) {
            return val;
        }

        const matchedByKey = this.sourceItems.find(item => {
            try {
                if (this.bulkActionsConfig && this.bulkActionsConfig.key) {
                    return this.isSameItem(item, val);
                }
            } catch (error) { }
            return false;
        });

        if (matchedByKey) {
            return matchedByKey;
        }

        if (val.id) {
            const matchedById = this.sourceItems.find(item => item && item.id === val.id);
            if (matchedById) {
                return matchedById;
            }
        }

        return val;
    }

    getCustomClass(item) {
        let customClass = '';
        if (item.class) {
            customClass += (item.class + ' ');
        }
        else if (item.freeze) {
            customClass += 'freeze ';
        }
        if (item.newLine) {
            customClass += ' newLine ';
        }

        return customClass;
    }

    hideFilter() {
        this.filterFieldGroup.blocks.list.filter.default_open = false;
        this.config['filterOpenStatus'] = false;
        if (this.filterFieldGroup.blocks.list.filter.default_open == false)
            this.config.canBeTriggered = false
        else {
            setTimeout(() => {
                this.config.canBeTriggered = true
            })
        }
        if (this.changeDetectorRef)
            this.changeDetectorRef.detectChanges()
        // if (this.filterFieldGroup.blocks.list.filter.hasOwnProperty('default_open')) {
        //     this.filterFieldGroup.blocks.list.filter.default_open = false;
        //     this.config['filterOpenStatus'] = this.filterFieldGroup.blocks.list.filter.default_open;
        // }
    }
    getHiddenField(field, item) {
        if (field.showField == undefined) {
            return true;
        } else {
            let val = eval(field.showField);
            if (val == undefined)
                return true;
            else
                return val;
        }
    }
    clickRow(field, data, index?) {
        data = this.getSourceItem(index, data);
        let rowClick = this.rowClick;
        this.setAccountAwareFacilityId(data);
        if (rowClick && Array.isArray(rowClick) && rowClick.length > 1) {
            let item = data;
            for (let i = 0; i < rowClick.length; i++) {
                if (rowClick[i].conditions && rowClick[i].conditions.expression) {
                    if (eval(rowClick[i].conditions.expression)) {
                        rowClick = rowClick[i];
                        break
                    }
                }
            }
        } else if (rowClick && Array.isArray(rowClick) && rowClick.length == 1) {
            rowClick = rowClick[0];
        }
        if (rowClick && Array.isArray(rowClick) && rowClick.length > 1) {
            rowClick = undefined;
        }
        if (field.config && field.config.buttonMenu && (field.config.type == 'ellipse' || field.config.type == 'button')) {
        } else if (rowClick != undefined) {
            if ((field.name == 'gridButton' && field.buttonList && field.buttonList.length > 0) || field.type == 'image' || field.type == 'link' || (field.showImage != undefined && field.showImage)) {
            }
            else if (rowClick.conditions != undefined && !Array.isArray(rowClick.conditions)) {
                let valid;
                let item = data;
                valid = eval(rowClick.conditions.expression)
                if (valid != undefined && valid != null && valid) {
                    let actionType = rowClick;
                    /********************ACCOUNT AWARE  *************/
                    this.setAccountAwareFacilityId(data);
                    /********************ACCOUNT AWARE  *************/

                    this.editEllipseClick.emit({ data, actionType });
                } else {
                    if (rowClick && rowClick.conditions && rowClick.conditions.err_message)
                        this.alerts.error(rowClick.conditions.err_message)
                }
            }
            else if (rowClick.conditions != undefined && Array.isArray(rowClick.conditions) && rowClick.conditions.length) {
                for (let val of rowClick.conditions) {
                    if (this.checkClickAvailability(data, val.expression, val.resource ? val.resource : false, val.permission_required ? val.permission_required : false, val.action_name ? val.action_name : false)) {
                        let actionType = val;
                        /********************ACCOUNT AWARE  *************/
                        this.setAccountAwareFacilityId(data);
                        /********************ACCOUNT AWARE  *************/
                        if (rowClick && rowClick.action && rowClick.action == "remote_confirm")
                            actionType = rowClick;
                        let itemIdLists = this.sourceItems.map(x => x.id);
                        this.editEllipseClick.emit({ data, actionType, itemIdLists });
                        break;
                    }
                }
            }
            else {
                let actionType = rowClick;
                this.setAccountAwareFacilityId(data);
                if (typeof actionType !== 'boolean') {
                    if (!rowClick.hasOwnProperty('permission_required'))
                        actionType['permission_required'] = true
                    if (actionType.action && (actionType.action == "modify" || actionType.action == "view") && actionType.permission_required) {
                        if (this.rolePermissionService.checkAccessPermission(actionType.action, this.config.resource))
                            this.editEllipseClick.emit({ data, actionType })
                    } else {
                        // this.editEllipseClick.emit({ data, actionType });
                        if (actionType?.action === "popup_form") {
                            this.checkBoxActions(actionType, data);
                        }
                        else {
                            this.editEllipseClick.emit({ data, actionType });
                        }
                    }
                } else {
                    this.editEllipseClick.emit({ data, actionType,field });
                }
            }
        } else {
            if ((field.name == 'gridButton' && field.buttonList && field.buttonList.length > 0) || field.type == 'image' || field.type == 'link') {
            } else {
                if (this.fields[this.fields.length - 1] != undefined && this.fields[this.fields.length - 1].config != undefined && this.fields[this.fields.length - 1].config.type == 'ellipse') {
                    let fields = this.fields[this.fields.length - 1].config.buttonMenu;
                    if (fields != undefined) {
                        let actionField = fields.find(val => {
                            return val.action == 'view' || val.label.toLowerCase() == 'view';
                        });
                        if (actionField && actionField.conditions)
                            for (let val of actionField.conditions) {
                                if (this.checkClickAvailability(data, val.expression, val.resource ? val.resource : false, val.permission_required ? val.permission_required : false, val.action_name ? val.action_name : false)) {
                                    let actionType = actionField;
                                    /********************ACCOUNT AWARE  *************/
                                    this.setAccountAwareFacilityId(data);
                                    /********************ACCOUNT AWARE  *************/
                                    this.editEllipseClick.emit({ data, actionType });
                                    break;
                                }
                            }
                        else if (actionField != undefined) {
                            let actionType = actionField;
                            /********************ACCOUNT AWARE  *************/
                            this.setAccountAwareFacilityId(data);
                            /********************ACCOUNT AWARE  *************/
                            this.editEllipseClick.emit({ data, actionType })
                        }
                    }
                }
            }
        }
    }
    //this function return row is clickable or not
    checkClickAvailability(item, expression, resource, permission_required?, action_name?) {
        let permission: boolean = true;
        if (permission_required != undefined && permission_required) {
            permission = this.rolePermissionService.checkAccessPermission(action_name, resource);
        }
        if (permission) {
            permission = eval(expression) != undefined && eval(expression) ? true : false;
        }
        return permission;
    }

    getExpression(field, item, type?) {
        try {
            if (field.expression) {
                let val = eval(field.expression)
                return val;
            } else if (field.checkbox_conditions && type == 'checkbox_conditions') {
                let val = eval(field.checkbox_conditions)
                return val;
            } else if (field.timeExpression && type == 'timeExpression') {
                let val = eval(field.timeExpression)
                return val;
            } else {
                return false;
            }
        } catch (error) { }
    }

    //this function returns dynamic class entered by user in json
    getClass(item, field?, fieldId?) {
        let class_: string = "";
        //this works for row
        if (this.config.class_conditions != undefined && this.config.class_conditions.length > 0) {
            return this.setclass(this.config.class_conditions, item, class_);
        }
        //this works for cell
        else if (field != undefined && field.class_conditions != undefined && field.class_conditions && field.class_conditions.length > 0 && !(field.name == 'priority' || field.name == 'priority_name' || field.name == 'servicePriority' || field.name == "highestPriority")) {
            return this.setclass(field.class_conditions, item, class_);
        }
        //this works for TAT
        else if (field != undefined && field.type == 'TAT') {
            return this.setTatFlag(field, item, class_);
        }
        else if (field != undefined && field.type == 'STARTSTAGETAT') {
            return this.setStartStageTatFlag(field, item, class_);
        }
        else if (this.isPriorityField(field)) {
            if (this.config.priorityApi) {
                this.config.priorityApi = false;
                this.commonService.getPriorityColor(() => this.refreshPriorityClasses());
            }
            class_ = this.getPriorityClass(item);
            if (fieldId != undefined)
                item[fieldId] = class_;
            return class_;
        }
        else if (field != undefined && field.wrap_text) {
            return 'text-wrap';
        }
        else if (field != undefined && field.name == 'uhId') {
 
            field.grid_color_text = true;
            field.class_condition = [{
                "expression": "item['uhId']",
                "class": "uhid-pill"
            }];
 
            return this.setclass(field.class_condition, item, class_);
        }  
        else {
            return class_;
        }
    }

    isPriorityField(field) {
        return field != undefined && field.name != undefined && (field.name == 'priority' || field.name == 'priority_name' || field.name == 'servicePriority' || field.name == "highestPriority");
    }

    getPriorityClass(item) {
        let priorityData;
        if(item.serviceType_code != undefined && item.serviceType_code != null && item.serviceType_code != '' ){
            priorityData = this.commonService.servicePriorityList != undefined ? this.commonService.servicePriorityList.find(x => (x.serviceType_code == item.serviceType_code) &&(x.service_priority_id == (item.priority_code || item.priorityCode || item.priority || item.priority_id || item.servicePriorityCode))) : '';
        }else{
            priorityData = this.commonService.servicePriorityList != undefined ? this.commonService.servicePriorityList.find(x => (x.serviceType_code == item.serviceType_code) || (x.service_priority_id == (item.priority_code || item.priorityCode || item.priority || item.priority_id || item.servicePriorityCode))) : '';
        }
        return priorityData != undefined && priorityData.color_Id != undefined ? priorityData.color_Id : '';

    }

    refreshPriorityClasses() {
        if (this.items == undefined || this.fields == undefined) {
            return;
        }
        this.items.forEach(item => {
            this.fields.forEach(field => {
                if (this.isPriorityField(field)) {
                    item[`gn_class_${field.field_id}`] = this.getPriorityClass(item);
                }
            });
        });
        if (this.changeDetectorRef)
            this.changeDetectorRef.detectChanges();
    }

    setclass(field, item, class_) {
        if (item != undefined) {
            for (let val of field) {
                if (eval(val.expression)) {
                    return class_ = val.class != undefined ? val.class : val.class_name ? val.class_name : '';
                }
            }
        }
    }

    setTatFlag(field, item, class_) {
        if (item.tat != undefined) {
            let fromMatched = this.baseService.buildDyanamicStr(field.currentStage, { data: item });
            let toMatched = 'end_stage';
            for (let obj of item.tat) {
                if (obj[toMatched] === fromMatched) {
                    let class_ = obj['critical_tat_expired'] != undefined && obj['critical_tat_expired'] ? 'grid-high-icon' : obj['warn_tat_expired'] != undefined && obj['warn_tat_expired'] ? 'grid-medium-icon' : '';
                    return class_;
                }
            }
        }
    }

    setTopViewForCard() {
        this.cardTopView = [
            {
                "heading": "field.label.facility_name",
                "card_tag": null,
                "order": 1,
                "sortable": true,
                "name": "facility_name"
            },
            {
                "heading": "field.label.desk_name",
                "card_tag": null,
                "order": 1,
                "sortable": true,
                "name": "desk_name"
            }
        ]
    }

    setStartStageTatFlag(field, item, class_) {
        if (item.tat != undefined) {
            let fromMatched = this.baseService.buildDyanamicStr(field.currentStage, { data: item });
            let toMatched = 'start_stage';
            for (let obj of item.tat) {
                if (obj[toMatched] === fromMatched) {
                    let class_ = obj['critical_tat_expired'] != undefined && obj['critical_tat_expired'] ? 'grid-high-icon' : obj['warn_tat_expired'] != undefined && obj['warn_tat_expired'] ? 'grid-medium-icon' : '';
                    return class_;
                }
            }
        }

    }

    setDataForFilter(e) {
        if (this.defaultDynamicfilter && this.defaultDynamicfilter.data) {
            let x = '';
            for (let key in this.defaultDynamicfilter.data) {
                if (x == undefined || x == '') {
                    x = key + ':' + this.defaultDynamicfilter.data[key]['value'];
                } else {
                    x = x + ',' + (key + ':' + this.defaultDynamicfilter.data[key]['value']);
                }
            }
            if (x == '' || x == undefined) {
                this.bindGrid.emit(e);
            } else {
                this.bindGrid.emit(e + "," + x);
            }
        } else {
            this.bindGrid.emit(e);
        }
    }

    getFilterPrintInfo(callback) {
        var data: any = {};
        data.action = "print";
        data.noComplexSearch = "print";
        data.file_data = {};
        data.file_data.file_type = "pdf";
        this.sendButtonData(data, (labelData) => {
            if (labelData != "" && labelData && labelData.file_data != undefined && labelData.file_data.filterPrintInfo != undefined && labelData.file_data.filterPrintInfo) {
                callback(labelData.file_data.filterPrintInfo);
            } else {
                callback(false)
            }
        });
    }

    doSearch(event) {
        setTimeout(() => {
            this.getFilterPrintInfo((filterPrintInfo) => {
                if (filterPrintInfo) {
                    this.configValues.emit({ 'filterPrintInfo': filterPrintInfo });
                    console.log("filterPrintInfo==>", filterPrintInfo);
                }

                // debugger;
                this.page = 1;
                this.configValues.emit({ 'changePage': this.page - 1 });

                //datasource removed 

                if (this.defaultDynamicfilter && this.defaultDynamicfilter != undefined) {
                    this.setDataForFilter(event);
                } else {
                    this.bindGrid.emit(event);
                }

                this.hideFilter();

                this.communicationService.emitChange({ completed: true });
            });
        });


    }

    doSearchWithBtn(event) {
        this.getFilterPrintInfo((filterPrintInfo) => {
            if (filterPrintInfo) {
                if (this.formBlock.decorator != undefined && this.filterFieldGroup.blocks != undefined && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list.filter && this.filterFieldGroup.blocks.list.filter.decorator != undefined && this.filterFieldGroup.blocks.list.filter.decorator && this.filterFieldGroup.blocks.list.filter.beforeGetRequestFilterDecorator) {
                    this.loader.showSpinner();
                    this.formBlock.filterDecorator = this.baseService.initDecorator(this.formBlock.decorator, this.route, this.injector);
                    this.formBlock.filterDecorator.beforeGetRequestFilterDecorator(filterPrintInfo, event, event.event, (cb) => {
                        if (cb) {
                            // do nothing
                        }
                        this.loader.hideSpinner();
                    });
                }
            }
        });
    }

    resetQuickFilter() {
        this.kxFilter['resetFormClick']({ resetQuickFilterForm: true });
    }

    emitDefaultFilter() {
        if (this.defaultDynamicfilter && this.defaultDynamicfilter != undefined) {
            this.applyFilter(this.defaultDynamicfilter);
        } else {
            this.bindGrid.emit();
        }
    }
    resetFilter(event, type) {
        this.ruleEngineService.setRuleArgs(false);
        this.page = 1;
        this.configValues.emit({ 'changePage': this.page - 1 });
        this.configValues.emit({ 'filterType': '' });
        if (this.config.filterConfig && this.config.filterConfig.resetQuickFilterForm != undefined && this.config.filterConfig.resetQuickFilterForm) {
            this.config.filterConfig.resetQuickFilterForm = false;
            // do nothing because already api will be called from doSearch method
        } else if (this.filterFieldGroup.blocks.list.filter.default_filter == undefined) {
            this.emitDefaultFilter();
        }
        if ((type == undefined || type == '') && this.config.filterConfig) {
            this.config.filterConfig.reset = new Date().getTime();
            this.config.filterConfig.quickReset = true;
            this.config.filterConfig = { ... this.config.filterConfig };
            delete this.config.filterConfig.FilterName;
            delete this.config.filterConfig.currentFilter;
            delete this.config.filterConfig.currentFilterName;
            this.config.filterConfig.submit = new Date().getTime();
        }
        if (type) {
            delete this.config.filterLabel;

            delete this.config.filterConfig.FilterName;
            delete this.config.filterConfig.currentFilter;
            delete this.config.filterConfig.currentFilterName;
            this.config.filterConfig.quickReset = false;
            this.displayFilter();
            setTimeout(() => {
                this.getFilterPrintInfo((filterPrintInfo) => {
                    if (filterPrintInfo) {
                        this.configValues.emit({ 'filterPrintInfo': filterPrintInfo });

                        console.log("filterPrintInfo==>", filterPrintInfo);
                    }
                    this.onClearClicked();
                    this.configValues.emit({ 'resetFilter': true });
                });
            }, 50);//giving some time to plat the form since the data is sent here is not needed immidiatley

        }
        // this.storageService.removeData('filterConfig', () => { });
    }
    ngOnInit() {

        if (this.config == undefined) {
            this.config = {};
            this.config.ruleEngine = {};
            this.config.binding = '';
        } else {
            this.config.binding = '';
        }
        if (this.config.ruleEngine == undefined) {
            this.config.ruleEngine = {};
        }
        // config.master_upload may be a single object (legacy) or an array of them
        if(this.config?.master_upload)
        {
        const mu = this.config.master_upload;
        this.masterUploadList = (!mu ? [] : Array.isArray(mu) ? mu : [mu]).filter(m => m?.resource &&
        this.rolePermissionService.checkAccessPermission(m.action || 'modify', m.permission_resource || 'master_upload', 'data-onboarding'));
        }
        if (this.fields == undefined) {
            this.fields = [];
        }
        for (let item of this.fields) {
            item['field_id'] = this.baseService.generateID(10);
        }
        if (this.config && this.config.jsonStructure == undefined)
            this.fields = JSON.parse(JSON.stringify(this.fields));
        this.config.orig_fields = JSON.parse(JSON.stringify(this.fields));
        this.config.bannerData = {};
        if (this.config && this.config.showBanner && this.config.showBanner.key) {
            this.config.bannerData = this.config.showBanner.key;
        }
        this.config.filterConfig = {};
        this._currentResource = this.config.resource;
        if (this.config.f__filterName != undefined) {
            this.config.filterConfig.FilterName = this.config.f__filterName;
        }
        if (this.config.filterName)
            this.config.filterConfig.FilterName = this.config.filterName;
        this.config.filterAr = [];
        if (this.config.table == undefined && this.config.tile == undefined) {
            this.config.table = true;
            this.config.activeField = 'table';
        }
        if (this.config.filterLabel != undefined && this.config.filterLabel) {
            this.config.filterConfig.filterLabel = this.config.filterLabel;
        }
        if (this.config.defFilters != undefined && this.config.defFilters) {
            this.config.filterConfig.defFilters = this.config.defFilters;
        }
        if (this.config.limit != undefined)
            this.limit = this.config.limit
        if (this.config.page_no != undefined)
            this.page = this.config.page_no + 1;
        if (this.config && !this.config.view_current_data && this.route.snapshot.queryParams && this.route.snapshot.queryParams["tab_1"] == "migrated_data_emr") { // need to rewrite code to remove this condition
            this.config.view_current_data = true;
        }

        this.config.downloadOnly = this.isDownloadOnly();
        this.archiveMessage = this.config && this.config.archiveMessage ? this.config.archiveMessage : this.archiveMessage;
        let mob = this.utilService.isOnlyMobile();
        if (mob || (this.config.tile && this.config.activeField == 'tile')) {
            this.config.tile = true;
            this.config.activeField = 'tile';
            this.fields = this.fields.filter(x => x.card_tag == null || x.card_tag > 0);
            this.fields.sort(function (a, b) {
                if ((a.card_tag != null && a.card_tag > 0) && (b.card_tag != null && b.card_tag > 0)) {
                    return a.card_tag - b.card_tag;
                }
            });
        }
        if (this.fields[this.fields.length - 1] != undefined && this.fields[this.fields.length - 1].config != undefined && (this.fields[this.fields.length - 1].config.type == 'ellipse' || this.fields[this.fields.length - 1].config.type == 'button')) {
            this.addTableClass = true;
            this.capabilityField = this.fields[this.fields.length - 1];
            //set config based capability
            if (this.capabilityField && this.capabilityField.config && this.capabilityField.config['buttonMenu'] && this.capabilityField.config['buttonMenu'].length > 0) {
                this.capabilityField.config['buttonMenu'].forEach((actionObj, i) => {
                    if (actionObj.config_datasource) {
                        this.configBasedCapability = true;//147980
                        let obj = actionObj.config_datasource;
                        this.sub.add(this.baseService.get(obj.queryId, obj.args, obj.resource, obj.application).subscribe(
                            result => {
                                if (result && result.errCode == 0 && result.resource && result.resource.length > 0 && result.resource[0].status == "active" && result.resource[0].config_value == 'yes') { }
                                else {
                                    this.capabilityField.config['buttonMenu'].splice(i, 1);
                                }
                            }));
                    }
                })
            }
        }
        //show/hide grid action buttons, via the resource's decorator
        let gridButtonField = this.fields.find(f => f.name == 'gridButton');
        if (gridButtonField && gridButtonField.buttonList && gridButtonField.buttonList.length > 0 && this.config && this.config.decorator && this.config.decorator.showAndHideGridButton != undefined) {
            try {
                this.config.decorator.showAndHideGridButton(gridButtonField.buttonList, (modifiedButtonList) => {
                    gridButtonField.buttonList = modifiedButtonList;
                });
            } catch (error) {
                console.log(error);
            }
        }
        this.HidetoggleVisibility(true, true);

        if (this.config.resource != undefined) {

            /******** AI SUMMARY ****************/
            if (this.config.aiSummary != undefined) {
                this.config.aiSummary.load = true;
            }
            /******** AI SUMMARY ****************/
            this.config.saveKey = this.config.resource + "_list_config";
            this.applyTableConfig(() => {
                this.computeColumnPercentages();
                if (this.config.dynamic_filter == undefined)
                    this.getSavedFilter();
            });
            //setting auto refresh 
            // removing auto refresh feature 
            // if (this.config.autorefresh != undefined && !this.utilService.isMobile()) {
            //     this.applyAutoRefresh(() => {
            //         if (this.autorefresh != undefined && this.autorefresh['config'] != undefined) {
            //             this.setIntervalAutoRef();
            //         }
            //     });
            // }
            if (this.config.barcode_config != undefined) {
                this.applyBarcodeScan(this.config.saveKey);
            }

        } else {
            this.computeColumnPercentages();
        }


        if (this.config && this.config.default_sorted && this.filterFieldGroup != undefined && this.filterFieldGroup.blocks.list.filter.default_filter == undefined) {
            this.applyDefaultSorting();
        }
        if (this.bulkActionsConfig && this.bulkActionsConfig.clearSelection) {
            this.sub.add(
                this.bulkActionsConfig.clearSelection.subscribe(_ => this.onClearClicked())
            );
        }

        this.config.printEngine = this.appService._currentSessionData.print_engine ? this.appService._currentSessionData.print_engine : false;

        this.buildCustomButtons();

        this.fetchItems();
        if (this.filterFieldGroup != undefined && this.filterFieldGroup.blocks != undefined && this.filterFieldGroup.blocks.list != undefined && this.filterFieldGroup.blocks.list.filter != undefined) {
            this.filterFieldGroup.blocks.list.filter.default_open = false; // settting defalt filter false hardcoded.
            this.config.canBeTriggered = false;
        }

        this.profileImg = this.appService._appData.PROFILE_LOGO;
        if (this.filterFieldGroup && this.filterFieldGroup.dynamic_filter) {
            this.setDynamicFilters();
        }
        this.config.priorityApi = true;
        //for audit log permission
        this.config['audit_log'] = this.config['audit_log'] === false ? false : this.rolePermissionService.checkAccessPermission('auditLog', this.config.resource);
        if (this.config && this.config.sorting_persisted && this.config.backendSorting != undefined && this.config.backendSorting) {
            this.currentSort.set(this.config.sorting_persisted.key, this.config.sorting_persisted.value == 'asc' ? 1 : -1);
        }
        //this.fields = this.fields.sort((a, b) => { return a.order - b.order });
        if (this.config && this.config.selectAllDefault) {
            this.noActionRequired = !this.config.noActionRequired
            this.onAllChecked(true)
        }
        if (this.config.direct_booking_toggle_button) {
            this.fetchDirectBookingStatus();
        }
    }
    fetchDirectBookingStatus() {
        this.baseService.get("GET_PAGE", "", "practitioner_facility_details_doctor", "facility-management", "practitioner_id:" + this.baseService.authenticationService.getCurrentUser().user_id).subscribe((res: any) => {
            if (res && res.resource && res.resource[0]) {
                this.isDirectBookingEnabled = res.resource[0].is_direct_booking === true;
            }
        });
    }
    isDownloadOnly() {
        if (this.config != undefined && this.config.archiveConfig != undefined && this.config.archiveConfig.selected != undefined && this.config.archiveConfig.selected.download_only != undefined && this.config.archiveConfig.selected.download_only) {
            return true;
        }
        // condition added if there is only use of download and no need to show archiveConfig button
        if (this.config != undefined && this.config.download_only != undefined && this.config.download_only) {
            return true;
        }
        return false;

    }
    ngOnChanges(change: SimpleChanges) {
        console.log("change", change);
        if (change.fields && Array.isArray(this.fields)) {
            this.fields.forEach(f => {
                if (!f.field_id) {
                    f.field_id = this.baseService.generateID(10);
                }
            });
            if (this.config && this.config.refreshOnFieldsChange && !change.fields.isFirstChange() && this.data) {
                this.extractData(this.data);//added because in html item['mappedValue_'+field.field_id] is getting undefined due to update field_id
            }
        }
    }
    toggleArchiveData(action) {
        this.configValues.emit({ 'archiveChange': action, config: this.config.archive });
    }
    setDynamicFilters() {
        if (this.page == undefined) {
            this.page = 1;
        }

        if (this.filterFieldGroup.dynamic_filter && Array.isArray(this.filterFieldGroup.dynamic_filter) && this.filterFieldGroup.dynamic_filter.length > 0) {
            let key = ''
            this.filterFieldGroup.dynamic_filter.forEach(element => {
                key += element + "#";
            });
            key = key.substring(0, key.length - 1);
            console.log("key  is ", key);
            this.preferenceService.getDynamicFilterData(key, async (res) => {
                if (res && res.length > 0) {
                    console.log("Filter ", res);
                    var _this = this;
                    await res.forEach(function (item, index) {
                        if (item['isDefault'] == true) {
                            _this.defaultDynamicfilter = item;
                            _this.applyFilter(item);
                            res.splice(index, 1);
                            return;
                        }
                    });
                    if (this.filterFieldGroup.quick_filters) {
                        this.filterFieldGroup.quick_filters = [...this.filterFieldGroup.quick_filters, ...res];
                    } else {
                        this.filterFieldGroup.quick_filters = res;
                    }
                    this.getSavedFilter();
                    //if default not true as ui engine is prohibited to call APi in case of dynamic filter
                    if (this.defaultDynamicfilter == undefined && this.filterFieldGroup && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list.filter.default_filter == undefined) {
                        this.configValues.emit({ 'loadSavedFilter': true });
                        this.bindGrid.emit();
                    }
                } else {
                    this.getSavedFilter();
                    if (this.filterFieldGroup && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list.filter.default_filter == undefined) {
                        this.configValues.emit({ 'loadSavedFilter': true });
                        this.bindGrid.emit();
                    }

                }
            });
        } else {
            this.getSavedFilter();
            if (this.filterFieldGroup && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list && this.filterFieldGroup.blocks.list.filter.default_filter == undefined)
                this.bindGrid.emit();
        }
    }
    setCardView() {
        if (this.items != undefined && this.items && this.items.length > 0) {
            this._cardFields = [];
            let fields = [...this.fields];
            if (this.cardHeaders != undefined && this.cardHeaders.fields != undefined) {
                for (let j = 0; j < fields.length; j++) {
                    if (this.cardHeaders.fields.includes(fields[j].name)) {
                        this._cardFields.push(fields[j]);
                        this.fields.splice(this.fields.map(x => x.name == fields[j].name).indexOf(true), 1);
                    }
                }
            }
        }
        else {
            console.log(this.items);
        }
    }
    setTemplateRef(item) {
        // text = [];
        let templateRef = {};
        this.cardHeaders.fields.forEach((valElem: string) => {
            // text.push(elem[valElem]);
            if (this.cardHeaders.template != undefined) {
                templateRef[valElem] = item[valElem]
            }
        });
        // elem['text'] = text.join(' | ');
        if (Object.keys(templateRef).length) {
            var tempData: any = {};
            tempData.data = templateRef;
            templateRef = this.baseService.buildDyanamicStr(this.cardHeaders.template, tempData);
        }
        return templateRef;
    }
    onColumnDragEnd(fromIndex, toIndex) {

        var tobeReplacedFieldName = jQuery('.resource_list_' + this.config.resource).find('thead tr th').eq(toIndex).data('name');
        var tobeReplacedFieldIndex = this.config.fieldOrder[tobeReplacedFieldName];
        var tobeReplacedField = this.fields[tobeReplacedFieldIndex];

        var tobemainFieldName = jQuery('.resource_list_' + this.config.resource).find('thead tr th').eq(fromIndex).data('name');
        var tobemainFieldIndex = this.config.fieldOrder[tobemainFieldName];
        var mainField = this.fields[tobemainFieldIndex];

        if (tobeReplacedFieldIndex == undefined || tobeReplacedField == undefined) {
            return;
        }
        this.fields[tobeReplacedFieldIndex] = mainField;
        this.fields[tobemainFieldIndex] = tobeReplacedField;
        this.config.fieldOrder[mainField.name] = tobeReplacedFieldIndex;
        this.config.fieldOrder[tobeReplacedField.name] = tobemainFieldIndex;
        this.getTableConfig((saveData) => {
            saveData = (saveData) ? saveData : {};

            saveData[tobeReplacedField.name] = (saveData[tobeReplacedField.name] == undefined) ? {} : saveData[tobeReplacedField.name];
            saveData[tobeReplacedField.name].order = tobemainFieldIndex;
            if (tobeReplacedField.hidden != undefined) {
                saveData[tobeReplacedField.name].hidden = tobeReplacedField.hidden;
            }

            saveData[mainField.name] = (saveData[mainField.name] == undefined) ? {} : saveData[mainField.name];
            saveData[mainField.name].order = tobeReplacedFieldIndex;
            if (mainField.hidden != undefined) {
                saveData[mainField.name].hidden = mainField.hidden;
            }
            this.saveTableConfigData(saveData);
        });

    }
    hidePopUp() {
        jQuery("popover-container").hide();
    }

    toggleBarcodeScan() {
        var key = this.config.resource + "_list_config";
        this.getTableConfig(saveData => {
            saveData = (saveData) ? saveData : {};
            if (this.config['barcodeConfig'] != undefined && this.config['barcodeConfig']['barcodeScan'] != undefined)
                saveData['barcodeConfig'] = {
                    'barcodeScan': !this.config['barcodeConfig']['barcodeScan']
                }
            this.config['barcodeConfig'] = saveData['barcodeConfig'];
            this.saveTableConfigData(key, saveData);
        });
        //no need of this will be removed further as this is handled at complex search
        if (this.config.barcodeConfig != undefined && this.config.barcodeConfig.barcodeScan != undefined && !this.config.barcodeConfig.barcodeScan) {
            // this.complexSearchRef.vc.first.nativeElement.focus();
        }

    }

    applyBarcodeScan(key) {
        if (this.config.barcode_config != undefined && this.config.barcode_config) {
            this.getTableConfig(data => {
                if (data && Object.keys(data).length && data.barcodeConfig != undefined) {
                    this.config['barcodeConfig'] = data.barcodeConfig;
                }
                else if (this.config.barcode_config != undefined && this.config.barcode_config) {
                    this.config['barcodeConfig'] = {
                        'barcodeScan': false
                    }
                }
            });
        }
    }

    applyAutoRefresh(callback) {
        if (this.config.autorefresh != undefined && this.config.autorefresh) {
            this.getTableConfig((data) => {
                if (data && Object.keys(data).length && data.autorefresh_ != undefined) {
                    this.autorefresh['config'] = data.autorefresh_;
                }
                else if (this.config.autorefresh != undefined && this.config.autorefresh) {
                    this.config.autorefresh['autorefresh'] = true;
                    this.autorefresh['config'] = this.config.autorefresh;
                }
                callback();
            });
        }
    }
    setIntervalAutoRef() {
        //remove auto refresh feature 
        return
        // this.autorefresh['id'] = setInterval(() => {
        //     if (this.page === 1 && this.autorefresh['config'].autorefresh) {
        //         this.onButtonClicked({
        //             "action": "refresh",
        //             "label": "field.label.refresh",
        //             "class": "fa fa-refresh",
        //             "permission_required": false
        //         });
        //     }
        // }, this.autorefresh['config'].interval);
        // this.autorefresh['config'].interval
    }
    toggleDirectBooking(event) {
        const is_direct_booking = event.target.checked;
        const datasource = this.config.direct_booking_toggle_button?.datasource || {};
        let payload = {
            practitioner_id: this.baseService.authenticationService.getCurrentUser().user_id,
            is_direct_booking: is_direct_booking
        };
        this.baseService.action(payload, datasource.action || 'UPDATE_DIRECT_BOOKING_STATUS', datasource.application || 'facility-management', datasource.resource || 'practitioner_facility_details').subscribe((res: any) => {
            if (res != undefined && res.errCode == 0) {
                this.isDirectBookingEnabled = is_direct_booking;
                this.alerts.success('Request Successful');
            } else {
                event.target.checked = this.isDirectBookingEnabled;
                this.alerts.error(res.message);
            }
        });
    }
    toggleEhrButton() {
        if (this.config.ehr_view_default) {
            this.config.ehr_view_default = false;
        } else {
            this.config.ehr_view_default = true;
        }
        this.bindGrid.emit('ehr_toggle');
    }
    secondaryUhidBtn() {
        if (this.config.secondary_uhid_default) {
            this.config.secondary_uhid_default = false;
        } else {
            this.config.secondary_uhid_default = true;
        }
        this.bindGrid.emit('secondary_uhid_toggle');
    }
    toggleAutoRefresh(action) {
        this.getTableConfig((saveData) => {
            saveData = (saveData) ? saveData : {};
            saveData['autorefresh_'] = {
                "interval": this.config.autorefresh.interval,
                "autorefresh": action
            };
            this.autorefresh['config'] = saveData['autorefresh_'];
            this.saveTableConfigData(saveData);
        });
    }


    applyTableConfig(callback) {
        this.getTableConfig((data) => {
            if (data && Object.keys(data).length) {
                for (let heading in data) {
                    var item = data[heading];
                    var fieldItem: any = false;
                    //handle visibility
                    if (item.hidden != undefined && this.config.fieldOrder[heading] != undefined) {
                        var index = this.config.fieldOrder[heading];
                        if (this.fields[index] != undefined) {
                            var fieldItem = this.fields[index];
                            fieldItem.hidden = item.hidden;
                            fieldItem.selected = !fieldItem.hidden;
                            this.config.viewAll = false;
                        }
                    }
                    //handle order
                    if (item.order != undefined && this.config.fieldOrder[heading] != undefined) {
                        if (!fieldItem) {
                            var index = this.config.fieldOrder[heading];
                            if (this.fields[index] != undefined) {
                                var fieldItem = this.fields[index];
                            }
                        }

                        if (fieldItem) {
                            if (this.fields[item.order] != undefined) {
                                var tobeReplacedField = this.fields[item.order];
                                this.fields[item.order] = fieldItem;
                                var newReplacedFieldIndex = this.config.fieldOrder[heading];
                                this.fields[newReplacedFieldIndex] = tobeReplacedField;
                                this.config.fieldOrder[heading] = item.order;
                                this.config.fieldOrder[tobeReplacedField.name] = newReplacedFieldIndex;

                            }
                        }
                    }
                    // setting hidden: false for auto_columns fields to be shown on grid
                    this.setAutoColumns(item);
                    this.config.fieldOrder[item.name] = index;

                    //handle sorting
                    if (heading == "frontend_sort_") {
                        this.config.FrontDefaultSort = {};
                        this.config.FrontDefaultSort.key = item.key;
                        this.config.FrontDefaultSort.type = item.value;
                    }
                }
            }

            this.setProjectionKeys();
            this.projectKeysSetting()
            callback();
        })
    }
    

   keyExtractionFromConfig(element) {
            if (element?.conditions?.length>0) {
                element.conditions.forEach(x => {
                    this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(x.expression)]
                });
            }
            if (element?.datasource?.args) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element.datasource.args)]
            }
            if (element?.query_params) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element?.query_params)]
            }
             if (element?.expression) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element.expression)]
            }
            if (element?.file_data?.args) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element?.file_data?.args)]
            }
            if (element?.redirectLink) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element?.redirectLink)]
            }
            if (element?.route_path?.redirectLink) {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element?.route_path?.redirectLink)]
            }
            if (element?.route_path?.query_params && typeof element?.route_path?.query_params === 'string') {
                this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element?.route_path?.query_params)]
            }
            if (element?.route_path?.queryParams && typeof element?.route_path?.queryParams === 'object') {
                let matches = Object.values(element.route_path.queryParams).map(value => String(value).match(/^!!!(.*?)!!!$/)?.[1]).filter(Boolean)
                if (matches.length > 0) {
                    this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...matches]
                }
            }
    }

    projectKeysSetting(){
            if (Array.isArray(this.capabilityField?.config?.buttonMenu) && this.capabilityField?.config?.buttonMenu?.length > 0) {
                this.capabilityField?.config?.buttonMenu.forEach(element => {
                    this.keyExtractionFromConfig(element);
                });
            }
            if (Array.isArray(this.rowClick) && this.rowClick?.length > 0) {
                this.rowClick.forEach(element => {
                this.keyExtractionFromConfig(element);
                });
            }
            let filteredFields = this.fields.filter(item => !item.hidden);
            filteredFields?.forEach(element => {
                if(element.format){
                    this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(element.format)]
                }
                if(element.image_conditions?.length>0){
                    element.image_conditions.forEach(el => {
                       this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(el.expression)]
                    });
                }
                if(element.class_conditions?.length>0){
                    element.class_conditions.forEach(el => {
                       this.commonService['visibleFields'] = [...this.commonService['visibleFields'], ...this.extractItemKeysFromString(el.expression)]
                    });
                }
            });
            this.commonService['visibleFields'] = [...new Set(this.commonService['visibleFields'])].toString()
    }

    extractItemKeysFromString(str: string): string[] {
    const keys = new Set<string>();

    const dotPattern = /item\.(\w+)/g;
    const bracketPattern = /item\[['"]([^'"]+)['"]\]/g;
    const regexPattern = /!!!(.*?)!!!/g;

    let match;

    // item.key
    while ((match = dotPattern.exec(str)) !== null) {
        keys.add(match[1]);
    }

    // item['key'] or item["key"]
    while ((match = bracketPattern.exec(str)) !== null) {
        keys.add(match[1]);
    }

    while ((match = regexPattern.exec(str)) !== null) {
        keys.add(match[1]);
    }


    return Array.from(keys);
    }

    setProjectionKeys() {
        try {
            let filteredFields = this.fields.filter(item => !item.hidden && item.hideColumn != true);
            this.config['projection_keys'] = this.baseService.getProjectionKeys(filteredFields, this.config.projection_keys);
            this.commonService['visibleFields'] = this.config['projection_keys'] ? this.config['projection_keys'] : []
        } catch (error) { }
    }

    setAutoColumns(item) {
        try {
            if (this.fields[item.order] != undefined && this.filterFieldGroup.blocks.config.auto_columns && this.filterFieldGroup.blocks.config.auto_columns.length > 0) {
                let auto_column_data = this.filterFieldGroup.blocks.config.auto_columns.filter(x => x.getterKey == this.fields[item.order].getterKey);
                if (auto_column_data != undefined && auto_column_data.length > 0) {
                    this.fields[item.order].hidden = false;
                }
            }
        } catch (error) {
            console.log("Error in setAutoColumns : " + error);
        }
    }

    removeFilters(data) {
        try {
            if (data != undefined && data['filter__'] != undefined && data['filter__'].length != undefined && data['filter__'].length > 0) {
                for (let i = 0; i < data['filter__'].length;) {
                    let item = data['filter__'][i];
                    if (this.rolePermissionService.checkAccessPermission('user_group_filter', 'user_group_filter', 'account-management') && (this.appService.getOrganization() && this.appService.getOrganization().org_id != undefined && item.facility_id != undefined && (this.appService.getOrganization().org_id == item.facility_id))) {
                        i = i + 1;
                    }
                    else if (item.userGroupId != undefined && item.userGroupId && (item.userGroupId != this.appService._currentSessionData.user_group)) {
                        data['filter__'].splice(i, 1);
                    }
                    else {
                        i = i + 1;
                    }
                }
            }
        } catch (error) {

        }

    }

    getAccountLevelFilters(data, cb) {
        try {
            this.getAllTableConfig((allData_) => {
                if (allData_ && allData_["account__" + this.config.saveKey] != undefined) {
                    var data_ = allData_["account__" + this.config.saveKey];
                    if (data.filter__ != undefined && data.filter__.length != undefined && data_.filter__ != undefined && data_.filter__.length != undefined) {
                        const arr = [...data.filter__, ...data_.filter__];
                        const dt = new Set(arr.map(item => item['key']));
                        data.filter__ = Array.from(dt, id => arr.find(item => item['key'] === id));
                    }
                    else if (!data.filter__) {
                        data['filter__'] = data_.filter__;
                    }
                }
                cb(true);
            });
        } catch (error) {
            cb(true);
        }

    }

    getSavedFilter(callback: any = false) {
        console.log("Config", this.config);
        this.getTableConfig((data) => {
            console.log("Quick Filters ", this.filterFieldGroup);
            //getting account 
            this.getAccountLevelFilters(data, (data_) => {
                if (data_) {
                    //removing filters 
                    this.removeFilters(data);

                    if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] != undefined) {
                        this.filterFieldGroup.quick_filters.forEach(function (item) {
                            item['type'] = 'quick';
                        });
                        this.config.filterAr = this.filterFieldGroup.quick_filters.concat(data['filter__']);
                        if (callback) {
                            callback(this.config.filterAr);
                        }
                    } else if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] == undefined) {
                        this.filterFieldGroup.quick_filters.forEach(function (item) {
                            item['type'] = 'quick';
                        });
                        this.config.filterAr = this.filterFieldGroup.quick_filters;
                        if (callback) {
                            callback(this.config.filterAr);
                        }
                    } else
                        if (data['filter__'] != undefined && data['filter__'].length) {
                            this.config.filterAr = data['filter__'];
                            if (callback) {
                                callback(data['filter__']);
                            }
                        } else {
                            this.config.filterAr = [];
                            if (callback) {
                                callback([]);
                            }
                        }
                }
            })
        });
    }

    checkFilterCondition(filter) {
        if (filter && filter.expression) {
            return eval(filter.expression)
        } else {
            return true;
        }
    }

    getNameExpression(format, item) {
        let value = '';
        try {
            value = eval(format)
        } catch (e) {
            value = '';
            // do nothing
        }
        return value;
    }

    applyFilter(filter) {
        this.ruleEngineService.setRuleArgs(false);
        this.ruleEngineService.reSetFilter(false);
        let res = this.config != undefined && this.config.resource != undefined ? this.config.resource : '';
        let hasActive = filter.name == this.config.filterConfig.FilterName
        this.storageService.getData('filterConfig' + res, (data) => {
            if (data && !hasActive) {
                this.storageService.removeData('filterConfig' + res, () => { });
                this.kxFilter['resetParams']('');
                this.storageService.getData('filterFormMapping' + res, (data_) => {
                    this.filterFormMapping = data_;
                });
                this.storageService.removeData('filterFormMapping' + res, () => { });
            }
            else if (data) {
                this.config.filterConfig = data;
                this.storageService.removeData('filterConfig' + res, () => { });
                // this.kxFilter['form']['resetOnlyForm']({});
                this.kxFilter['resetParams']('');
                this.storageService.getData('filterFormMapping' + res, (data_) => {
                    this.filterFormMapping = data_;
                });
                this.storageService.removeData('filterFormMapping' + res, () => { });
                this.config.stopChangeProp = true;
                this.kxFilter['stopChangeProp'] = true;
            }
        })
        if (this.config.filterConfig && this.config.filterConfig.FilterName != undefined && (this.config.filterConfig.currentFilterName == filter.key)) {
            this.filterFieldGroup.blocks.list.filter.default_open = true;
            this.kxFilter['stopChangeProp'] = false;
            this.kxFilter['resetFormClick']('')
            this.resetFilter(filter, false);
        } else {
            if (filter.data != undefined && this.filterFormMapping != undefined && this.filterFormGroup != undefined) {
                var oldFilterMapping = { ...this.filterFormMapping };
                this.config.filterConfig = { ... this.config.filterConfig };
                this.config.filterConfig.reset = new Date().getTime();
                this.config.filterConfig.currentFilter = filter.key;
                this.config.filterConfig.FilterName = filter.name;
                this.config.filterConfig.quickReset = false;
                if (filter.isRule != undefined && filter.isRule) {
                    this.ruleEngineService.setRuleArgs(true);
                    this.ruleEngineService.reSetFilter(false);
                }
                setTimeout(async () => {
                    for (let f in filter.data) {
                        if (this.filterFormGroup && this.filterFormGroup.controls && this.filterFormGroup.controls[f] != undefined && oldFilterMapping[f] != undefined) {
                            if (filter.data[f]['type'] == undefined)
                                filter.data[f]['type'] = oldFilterMapping[f]['controlType'];
                            if (filter.subType != undefined && filter.subType == 'dynamic') {
                                this.configValues.emit({ 'filterType': 'dynamic' });
                            } else {
                                this.configValues.emit({ 'filterType': '' });
                            }
                            if (filter.type != undefined && filter.subType == undefined && (oldFilterMapping[f]['controlType'] == 'dropdown' || oldFilterMapping[f]['controlType'] == 'searchselect')) {
                                //console.log("Options ", oldFilterMapping[f].options);
                                if (filter.dynamic_str) {
                                    if (filter.data[f].value.indexOf('!!!') != -1)
                                        filter.data[f].value = this.baseService.buildDyanamicStr(filter.data[f].value, { data: null });
                                    if (this.filterFormGroup.controls[f].question_component)
                                        this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                                    this.filterFormGroup.controls[f].setValue(filter.data[f].value);
                                } else {
                                    await oldFilterMapping[f].options.find(val => {
                                        if (val[oldFilterMapping[f].getterValue] == filter.data[f].value) {
                                            if (this.filterFormGroup.controls[f].question_component)
                                                this.filterFormGroup.controls[f].question_component.updateDependentValue(val[oldFilterMapping[f].getterKey]);
                                            this.filterFormGroup.controls[f].setValue(val[oldFilterMapping[f].getterKey]);
                                        }
                                    });
                                }
                            } else if (oldFilterMapping[f].controlType == "daterangepicker" && !oldFilterMapping[f].singleDatePicker) {
                                let date;
                                if (filter.data[f] && filter.data[f].custom != undefined && filter.data[f].custom && filter.data[f].value != undefined) {
                                    if (filter.data[f].originalFrom && filter.data[f].originalTo) {
                                        date = [filter.data[f].originalFrom, filter.data[f].originalTo];
                                    } else {
                                        const daysDiff = filter.data[f].value;
                                        if (daysDiff === 1) {
                                            const startOfToday = moment().startOf('day').valueOf();
                                            const endOfToday = moment().endOf('day').valueOf();
                                            date = [startOfToday, endOfToday];
                                        } else {
                                            date = [moment().valueOf(), new Date(moment().add(daysDiff - 1, 'days').valueOf()).setUTCHours(23, 59, 59, 999)];
                                        }
                                    }
                                }
                                else {
                                    date = await DateRangeConfig[filter.data[f].value]();
                                }
                                if (date != undefined)
                                    if (this.filterFormGroup.controls[f].question_component)
                                        this.filterFormGroup.controls[f].question_component.updateDependentValue({ "FROM": date[0], "TO": date[1] });
                                if (this.filterFormGroup.controls[f].question_component.question.startKey != 'FROM') {
                                    this.filterFormGroup.controls[f].setValue({ [this.filterFormGroup.controls[f].question_component.question.startKey]: date[0], [this.filterFormGroup.controls[f].question_component.question.endKey]: date[1] });
                                } else
                                    this.filterFormGroup.controls[f].setValue({ "FROM": date[0], "TO": date[1] });

                            } else {
                                if (this.filterFormGroup.controls[f].question_component)
                                    this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                                this.filterFormGroup.controls[f].setValue(filter.data[f].value);

                            }
                        }
                    }
                    this.kxFilter['stopChangeProp'] = false;
                    this.configValues.emit({ 'filterName': this.config.filterConfig.FilterName })
                    this.config.filterConfig = { ... this.config.filterConfig };
                    let res = this.config != undefined && this.config.resource != undefined ? this.config.resource : '';
                    this.storageService.setData('filterConfig' + res, this.config.filterConfig, () => { })
                    this.config.filterConfig.submit = new Date().getTime();
                    this.storageService.setData('filterFormMapping' + res, this.filterFormMapping, () => { });
                })
                this.config.stopChangeProp = false;
            }

        }
    }

    manageFilter() {
        if (this.config.saveKey == undefined) {
            console.error("resource not found");
        } else {
            this.getSavedFilter((filterData) => {
                let popobj = { data: { self: this, data: filterData }, title: 'Manage Your Filters', size: DialogModalSize.Sm };
                this.dialogService.open(ManageFilterComponent, popobj).afterClosed.subscribe(
                    res => {
                        this.getSavedFilter();
                        this.resetFilter('', false);
                    });

            });
        }
    }

    getTableConfig(callback, account?) {
        // if(this.config.allowConfigGrid){
        var key = this.config.saveKey;
        //if account is true then we will not load the cached data
        this.preferenceService.getUserPreferenceConfig(key, (data) => {
            if (!account) {
                this.config.localStorageData = data;
            }
            callback(data);
        }, account);
        // }else{
        //     callback(false);
        // }
    }

    getAllTableConfig(callback, account?) {
        // if(this.config.allowConfigGrid){
        var key = this.config.saveKey;
        //if account is true then we will not load the cached data
        this.preferenceService.getUserPreferenceConfig([key], (data) => {
            callback(data);
        });
        // }else{
        //     callback(false);
        // }
    }

    resetDefaultConfig() {
        if (this.config.resource == undefined) {
            console.error("resource not found");
        } else {
            this.fields = JSON.parse(JSON.stringify(this.config.orig_fields));;
            var filterFound = false;
            this.getTableConfig((saveData) => {
                if (saveData) {
                    if (saveData && saveData["filter__"] != undefined) {
                        filterFound = true;
                    }
                    if (filterFound) {
                        var dialogRef = this.modalService.confirmCustomBtn("Remove Filter?", "You have some saved filter, do You want to delete it too?", ModalSize.Sm, { cancel: "NO", ok: "YES" });
                        dialogRef.subscribe(result => {
                            if (result) {
                                this.delteConfigData();
                            } else {
                                var obj = {};
                                obj["filter__"] = saveData["filter__"];
                                this.saveTableConfigData(obj, () => {
                                    this.getSavedFilter();
                                    this.resortFields();
                                });
                            }
                        });
                    } else {
                        this.delteConfigData();
                    }
                }
            });
        }
    }

    delteConfigData() {
        var key = this.config.saveKey;
        this.preferenceService.delteConfigData(key, () => {
            this.getSavedFilter();
            this.resortFields();
        });
    }

    resortFields() {
        // ******** Decorator Implemented ******** //
        if (this.config.decorator != undefined && this.config.decorator && this.config.decorator.resetDefault) {
            let fields = this.config.decorator.resetDefault(this.fields);
            this.fields = fields;
        } else
            this.fields.sort((a, b) => { return a.order - b.order });
        this.HidetoggleVisibility(true, true);
        this.removeDragListner();
        this.tableInitalized = false;
    }
    saveTableConfig(name: any = true) {
        if (this.config.resource == undefined) {
            console.error("resource not found");
        } else {
            this.getTableConfig((saveData) => {
                if (saveData) {
                    saveData = (saveData) ? saveData : {};
                    if (typeof name == 'boolean') {
                        this.fields.forEach((item, index) => {

                            if (item.name != undefined && item.name != "") {
                                this.config.fieldOrder[item.name] = index;
                                name = item.name;
                                saveData[name] = (saveData[name] == undefined) ? {} : saveData[name];

                                saveData[name].order = index;

                                if (item.hidden != undefined) {
                                    saveData[name].hidden = item.hidden;
                                }
                            }

                        });
                    } else {
                        var item: any = false;
                        var index = this.config.fieldOrder ? this.config.fieldOrder[name] : undefined;
                        if (this.fields[index] != undefined) {
                            item = this.fields[index];
                        }
                        if (item) {
                            saveData[name] = (saveData[name] == undefined) ? {} : saveData[name];
                            saveData[name].order = index;
                            if (item.hidden != undefined) {
                                saveData[name].hidden = item.hidden;
                            }
                        }
                    }
                    this.saveTableConfigData(saveData);
                }
            });
        }
    }

    saveTableConfigData(data, callback: any = false, userScope?, del?) {
        var key = this.config.saveKey;
        let data__ = JSON.parse(JSON.stringify(data));
        if (userScope) {
            this.getTableConfig((all_resource_data) => {
                var account_data: any = {};
                if (all_resource_data["account__" + key] != undefined) {
                    account_data = all_resource_data["account__" + key];
                }
                if (account_data.filter__ != undefined && account_data.filter__.length != undefined && account_data.filter__.length > 0) {
                    if (del) {
                        data__.filter__ = JSON.parse(JSON.stringify(account_data.filter__));//if it is being deleted then we get the latest data from server and then remove the key which is deleted by user
                    } else {
                        data__.filter__ = [...data__.filter__, ...account_data.filter__];
                    }

                }
                if (data__.filter__ != undefined && data__.filter__.length != undefined && data__.filter__.length > 0) {
                    data__.filter__ = data__.filter__.filter(x => x.userGroupId != undefined && x.userGroupId)
                }
                if (del) {
                    //delete case
                    let delIndex = data__.filter__.findIndex(x => x.key != undefined && x.key == del);
                    if (delIndex > -1) {
                        data__.filter__.splice(delIndex, 1);
                    } else {
                        this.alerts.error("ERROR");
                        console.error("Deleted Filter key not found");
                    }
                    console.log("delIndex==>", delIndex);
                }

                key = 'account__' + key;

                account_data['filter__'] = data__.filter__;

                // this.preferenceService.getConfigurationData({ key: key }, (configdata) => { 
                // debugger;
                this.preferenceService.saveConfigurationData({ key: key }, account_data, (result) => {
                    callback()
                });
                // })

            }, true);//forcing to get data from db and not use cached data in localstorage
        }
        else
            this.preferenceService.saveTableConfigData(key, data, callback);

    }


    buildCustomButtons() {
        if (this.config != undefined && (this.config.customButtonsAllowed || this.config.customButtonsAllowed == undefined)) {

            var customActions = [];
            if (this.config.custom_button == undefined) {
                this.config.custom_button = [];
            } else {
                for (let button of this.config.custom_button) {
                    customActions.push(button.action);
                }
            }
            if (this.config.print_allowed != undefined && this.config.printActions == undefined) {
                if (this.config.print_allowed && Array.isArray(this.config.print_allowed) && this.config.print_allowed.length) {
                    for (let action of this.config.print_allowed) {
                        if (customActions.indexOf(action) == -1) {
                            this.addCustomButtons(action);
                        }
                    }
                }
            }
            else {
                if (customActions.indexOf('print') == -1) {
                    if (this.config.printActions != undefined) {
                        this.addPrintActions();
                    }
                    else {
                        this.addCustomButtons('print');
                    }
                }
                if (customActions.indexOf('download') == -1) {
                    if (this.config.downloadActions != undefined) {
                        this.addDownloadActions('download');
                    }
                    else {
                        this.addCustomButtons('download');
                    }
                }
                if (customActions.indexOf('refresh') == -1) {
                    this.addCustomButtons('refresh');
                }
            }
            this.config.custom_button = this.rolePermissionService.getAllowedContextMenu(false, this.config.custom_button, this.config.resource);
        }
    }

    addPrintActions() {
        var pactions = [
            {
                "action": "print",
                "label": "field.label.print",
                "permission_required": false,
                "isGrid": true,  //for button action condition on preprint function
                "file_data": {
                    "file_type": "pdf"
                }
            }
        ];
        if (this.config.printActions != undefined) {
            var checkExists = pactions.every(x => {
                return this.config.printActions.findIndex(y => y.label == x.label) > -1;
            });
            if (!checkExists)
                this.config.printActions = [...pactions, ...this.config.printActions];
        }
    }
    addDownloadActions(action) {
        var dactions = [{
            "action": "download",
            "label": "field.label.download",
            "class": "fa fa-download",
            "permission_required": false,
            "file_data": {
                "file_type": "xlsx"
            }
        }
        ];
        if (this.config.downloadActions != undefined) {
            let downloadActions = this.config.downloadActions;
            downloadActions.forEach(element => {
                dactions.push(element);
            });
            this.config.downloadActions = dactions;
        } else {
            var checkExists = dactions.every(x => {
                return this.config.downloadActions.findIndex(y => y.label == x.label) > -1;
            });
            if (!checkExists)
                this.config.downloadActions = [...dactions, ...this.config.downloadActions];
        }
    }
    addCustomButtons(action) {
        switch (action) {
            case "print":
                this.config.custom_button.push({
                    "action": "print",
                    "label": "field.label.print",
                    "class": "fa fa-print tq-color-print",
                    "permission_required": false,
                    "file_data": {
                        "file_type": "pdf"
                    },
                    "isUserPrint": true,
                    "isGrid": true,  //for button action condition on preprint function
                    "isPrePrintAction": true // Need to delete as it is not in use
                });
                break;
            case "download":
                this.config.custom_button.push({
                    "action": "download",
                    "label": "field.label.download",
                    "class": "fa fa-download tq-color-download",
                    "permission_required": false,
                    "file_data": {
                        "file_type": "xlsx"
                    }
                });
                break;
            case "refresh":
                this.config.custom_button.push({
                    "action": "refresh",
                    "label": "field.label.refresh",
                    "class": "fa fa-refresh tq-color-refesh",
                    "permission_required": false
                });
                break;
            default:
                break;
        }
    }

    emitId(id: any, index) {
        this.editClick.emit({ id, index });
    }
    //this will open prepopup and append the reult to the args 
    prePrint(action, val, index, $event?, res?, callback?) {
        /* let prePrintObj = action.pre_print;
         action['form'] = action.pre_print.form;*/
        let isPrePrintAction = true;
        let print_without_h_f = this.appService._currentSessionData.print_without_h_f;
        if (res && res.print_without_h_f != null) {
            print_without_h_f = res.print_without_h_f;
        }
        console.log("print_without_h_f::::!!!", print_without_h_f);
        let defaultPageLayout = "portrait";
        if (res && res.page_layout != null && res.page_layout !== '') {
            defaultPageLayout = res.page_layout;
        }
        let defaultPrint = "Y";
        let isNoOfPrintCopy = false;
        // isNoOfPrintCopy = this.appService.getAccountConfigValue('MultiplePrintCopy') != undefined && action?.isNoOfPrintCopy == true;
        let override_print_copies = true;

        if (res?.no_of_print_copy > 1) {
            isNoOfPrintCopy = true;
        }

        if (res?.override_print_copies === true) {
            override_print_copies = false;
        }

        if (action.isGrid != undefined && action.isGrid == true) {
            isNoOfPrintCopy = false;
        }

        if (print_without_h_f != undefined && print_without_h_f == true && this.baseService.authenticationService.getUserType() != 'patient') {
            defaultPrint = "N";
        }
        if (action && action.isUserPrint != undefined && action.isUserPrint == true && action && action.isPrePrintAction != undefined && action.isPrePrintAction == true) {
            isPrePrintAction = true;
        }
        if (action && (action.isUserPrint != undefined && action.isUserPrint == true) || (action.isGrid != undefined && action.isGrid == true)) {
            let pre_print = {
                "title": "",
                "form": {
                    "buttons": {
                        "Add": [
                            {
                                "label": "Print",
                                "action": "prePrint"
                            }
                        ]
                    },
                    "blocks": [
                        {
                            "name": "pre_print",
                            "class_name": "null",
                            "layout_type": "no-column",
                            "order": 1,
                            "fields": [
                                {
                                    "label": "Select Print Header & Footer Type?",
                                    "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                                    "order": 2,
                                    "type": "String",
                                    "component": "dropdown",
                                    "name": "userPrint",
                                    "default": defaultPrint,
                                    "datasource": {
                                        "possible_value": [
                                            {
                                                "id": "Y",
                                                "value": "With Header & Footer"
                                            },
                                            {
                                                "id": "N",
                                                "value": "Without Header & Footer"
                                            }
                                        ]
                                    }
                                },
                                {
                                    "label": "Select Layout Type?",
                                    "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                                    "order": 2,
                                    "type": "String",
                                    "component": "dropdown",
                                    "name": "page_layout",
                                    "default": defaultPageLayout,
                                    "visible": isPrePrintAction,
                                    "datasource": {
                                        "possible_value": [
                                            {
                                                "id": "landscape",
                                                "value": "Landscape"
                                            },
                                            {
                                                "id": "portrait",
                                                "value": "Portrait"
                                            }
                                        ]
                                    }
                                },
                                {
                                    "label": "No of Print Copy",
                                    "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                                    "order": 3,
                                    "type": "Integer",
                                    "visible": isNoOfPrintCopy,
                                    "disabled": override_print_copies,
                                    "component": "numberbox",
                                    "name": "no_of_print_copy",
                                    "default": res?.no_of_print_copy ?? 1
                                }
                            ]
                        }
                    ]
                }
            };
            var prePrintObj = pre_print;
            action['form'] = pre_print.form;
        }
        else {
            prePrintObj = action.pre_print;
            action['form'] = action.pre_print.form;
        }
        let obj: any = Object.assign({ action }, { val });
        if (this.baseService.authenticationService.getUserType() == 'patient') {
            if (action && action.file_data && action.file_data.args) {
                action.file_data.args = action.file_data.args != undefined && action.file_data.args != "" ? action.file_data.args + ",userPrint:Y,page_layout:portrait" : "userPrint:Y,page_layout:portrait";
            } else {
                let action = { file_data: { args: "" } };
                action.file_data.args = "userPrint:Y,page_layout:portrait";
            }
            // action.file_data.args = action.file_data.args != undefined && action.file_data.args != "" ? action.file_data.args + ",userPrint:Y,page_layout:portrait" : "userPrint:Y,page_layout:portrait";
            let patient_action = JSON.parse(JSON.stringify(action));
            this.sendButtonData(patient_action);
            return;
        }
        this.smartModalService.open(DynamicPopUpComponent, obj, prePrintObj.title != undefined ? prePrintObj.title : "", ModalSize.Md).subscribe(res => {
            if (res) {
                let action_ = JSON.parse(JSON.stringify(action));
                let str = res.result;
                if (str) {
                    for (let key in str) {
                        if (key != undefined && str[key] != undefined && str[key]) {
                            if (action_.file_data.args && action_.file_data.args != undefined) {
                                action_.file_data.args = action_.file_data.args + "," + key + ":" + str[key];
                            }
                            else {
                                action_.file_data.args = key + ":" + str[key];
                            }
                        }
                    }
                }

                if (action && action.isGrid != undefined && action.isGrid == true) {
                    this.sendButtonData(action_);
                }
                else {
                    this.emitAction(val, action_, index, $event);
                }
                //callback(true);
            }
        },
            err => {
                console.log("err");
            }
        );
    }


    checkTemplates(data_, action,actiontype? , cb?) {
        try {
            this.loader.showSpinner();
            let datasource = action.templateInterceptor.datasource;

            data_['next_stage'] = action.templateInterceptor.next_stage;
            if (data_ != undefined && !data_.care_type) {
                try {
                    data_['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
                } catch (error) { }
            }
            if (datasource?.appendArgs) {
                datasource.args = (datasource.args || "") + "," + this.manupulateArgs(Array.isArray(data_) ? data_[0] : [data_], datasource.appendArgs);
            }
            if (data_ != undefined && data_.patient_gender) {
                data_['patient_gender'] = (data_.patient_gender + '').toLowerCase();
            }
            let args = this.baseService.buildDyanamicStr(datasource.args, { data: Array.isArray(data_) ? data_[0] : data_});
            this.isCountClick = false
            this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
                if (data.errCode != -1 && data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
                    if (cb) {
                        this.loader.hideSpinner();
                        cb(true);
                        return;
                    }
                    this.openTemplIntersep(data_, { templateInterceptor: action.templateInterceptor }, false, (res) => {
                        if (res) {
                            this.checkBoxActions(action, data_,actiontype);
                        }
                    });
                }
                else {
                    this.loader.hideSpinner();
                    if (cb) {
                        cb(false);
                        return;
                    }
                    this.checkBoxActions(action, data_,actiontype);
                }
            })

        } catch (error) {
            this.loader.hideSpinner();
            if (cb) {
                cb(false);
                return;
            }
            this.checkBoxActions(action, data_,actiontype);
        }
    }

    emitEllipseId(data: any, actionType, index?, $event?) {
        data = this.getSourceItem(index, data);
        let decorator_instance = this.baseService.initDecorator(actionType.decorator, this.route, this.injector);
        // let _actionType = 
        let decorator_data = { actionType: actionType, _currentData: data, data: data }
        const handleCapabilityClick = (val) => {
            if (val) {
                if (this.appService.isFacilityAware()) {
                    this.setAccountAwareFacilityId(data);
                }
                if (actionType.action == "video_popup") {
                    this.openVideoPopup(actionType, data);
                }
                if (actionType.action == "social") {
                    this.socialCalling(actionType, data); // to make buttons on cards actionable @author Sauravdeep
                }
                if (actionType.action == "QrCode") {
                    this.generateQRCode(actionType, data); // to make buttons on cards actionable @author Sauravdeep
                }

                if (actionType.action == 'popup_form') {
                    if (actionType != undefined && actionType.templateInterceptor != undefined) {
                        this.checkTemplates(data, actionType);
                    }
                    else {
                        this.checkBoxActions(actionType, data);
                    }

                    // this.checkBoxActions(actionType, data);
                }
                else if ((actionType.pre_print != undefined && actionType.pre_print) || (actionType.isUserPrint != undefined && actionType.isUserPrint)) {
                    // this.prePrint(actionType, data, index, $event);
                    try {
                        console.log("Inside PTS Condition");
                        this.utilService.performPreprintAction(
                            this.baseService,
                            actionType,
                            (res: any) => this.prePrint(actionType, data, index, $event, res),
                            (res: any) => this.emitAction(data, actionType, index, $event, this.sourceItems?.map(x => x?.id))
                        )
                    } catch (err) {
                        console.error("Unexpected error in match block:", err);
                        this.prePrint(actionType, data, index, $event);
                    }
                }
                else {
                    this.emitAction(data, actionType, index, $event, this.sourceItems?.map(x => x?.id));
                }
            }

        };

        if (decorator_instance && typeof decorator_instance.capabilityClick == 'function') {
            decorator_instance.capabilityClick(decorator_data, handleCapabilityClick);
        }
        else {
            handleCapabilityClick(true);
        }
    }
    emitAction(data: any, actionType, index?, $event?, itemIdLists?) {
        //interseptor for template will open template before next action  
        //isconsentreq is checked as it is mandatory for getting template
        // todo: - remove not to check consent key
        var actionType_config = JSON.parse(JSON.stringify(actionType))
        if (actionType_config && actionType_config.templateInterceptor && actionType_config.templateInterceptor.datasource) {
            this.checkTemplates(data, actionType_config, undefined, (hasTemplate: boolean) => {
                if (hasTemplate) {
                    this.openTemplIntersep(data, actionType_config, (actionType_config.config ? actionType_config.config : undefined), (data_) => {
                        this.finalemitAction(data, actionType_config, index, $event, itemIdLists);
                    });
                } else {
                    this.finalemitAction(data, actionType_config, index, $event, itemIdLists);
                }
            });
        }
        else if (actionType_config && actionType_config.templateInterceptor && ((data.isConsentRequired != undefined && data.isConsentRequired) || actionType_config.notToCheckConsent)) {
            if (actionType_config.templateInterceptor.datasource)
                actionType_config.templateInterceptor.datasource.args = actionType_config.templateInterceptor.datasource.args ? this.baseService.buildDyanamicStr(actionType_config.templateInterceptor.datasource.args, { data: data }) : '';
            this.openTemplIntersep(data, actionType_config, (actionType_config.config ? actionType_config.config : undefined), (data_) => {
                this.finalemitAction(data, actionType_config, index, $event, itemIdLists);
            });
        }
        else {
            this.finalemitAction(data, actionType_config, index, $event, itemIdLists);
        }
    }
    finalemitAction(data: any, actionType, index?, $event?: any, itemIdLists?) {
        if (index != undefined) { this.editEllipseClick.emit({ data, actionType, index, $event, itemIdLists }); }
        else {
            this.editEllipseClick.emit({ data, actionType, $event, itemIdLists });
        }
    }
    public onLimit(event) {
        this.limit = event.target.value;
        this.page = 1;
        if (this.config.insidePopup != undefined && this.config.insidePopup) {
            this.onLimitChange.emit(event);
        } else {
            if (this.limit <= 25) {
                this.storageService.removeData(this.config.saveKey + "__limit", () => { });
                this.getTableConfig((saveData) => {
                    if (saveData) {
                        saveData = (saveData) ? saveData : {};
                        saveData['limit_'] = this.limit;
                        this.saveTableConfigData(saveData);
                        this.onLimitChange.emit(event);
                    }
                });
            } else {
                this.saveLimitInStorage(this.limit, () => {
                    this.onLimitChange.emit(event);
                });
            }
        }
    }
    generateQRCode(data, action) {
        let lbl = "QR Code Generator"; let obj = { "data": data, "action": action };
        this.smartModalService.open(QrCodeGeneratorComponent, obj, lbl, ModalSize.Sm).pipe(take(1)).subscribe(
            response => {
                // this.redirectToOtherPage(response.result.resource[0], 'popup');
            }, err => { }
        );
    }
    pageConfigChange(event) {
        this.configValues.emit({ 'getCount': true });
        setTimeout(() => {
            this.editEllipseClick.emit({ 'actionType': { action: "refresh" } });
        })
    }

    saveLimitInStorage(limit, callback) {
        this.storageService.setData(this.config.saveKey + "__limit", limit.toString(), () => {
            callback()
        });
    }
    // private onFilter(event){
    //     setInterval(function(){ console.log("Event is ",event);this.onFilterChange.emit(event); }, 3000);
    // }
    resetSearch(event) {
        this.getFilterPrintInfo((filterPrintInfo) => {
            this.configValues.emit({ 'filterPrintInfo': filterPrintInfo });
            this.filterClick(event);
        });
    }
    filterClick(event) {
        event ? this.gridPrintFlag = true : this.gridPrintFlag = false;
        this.page = 1;
        if (this.config.not_found_text) {
            delete this.config.not_found_text;
        }
        this.configValues.emit({ 'changePage': this.page - 1 });
        if (event == "" || event && event.value != "") {
            if (event && event.value != '' && event.searchObj) {
                this.getTableConfig((saveData) => {
                    if (saveData) {
                        saveData = (saveData) ? saveData : {};
                        saveData['complex_search'] = event.searchObj;
                        this.saveTableConfigData(saveData);
                    }
                });
            }
            this.onFilterChange.emit(event);
        }
    }

    openTemplIntersep(data: any, actionType, config?, callback?) {
        let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
        if (config)
            popobj.data['config'] = config
        this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(
            res => {
                if (res)
                    callback(true);
            });
    }

    onPageChanged(event: any) {
        this.page = event.page;
        this.onPageChanges.emit(this.page);
        if (this.utilService.isOnlyMobile()) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }
    clearSort() {
        this.loader.showSpinner();
        this.currentSort.clear();
        this.items = this.cloneItems;
        if (this.sourceItems && Array.isArray(this.sourceItems)) {
            try {
                this.sourceItems = JSON.parse(JSON.stringify(this.cloneItems));
            } catch (err) {
                console.error('Failed to restore sourceItems on clearSort:', err);
            }
        }
        this.loader.hideSpinner();
        this.rebuildContextMenuAfterSort();
        this.onSortChanges.emit({ frontendSorting: true, clear: true });
        this.getTableConfig((saveData) => {
            saveData = (saveData) ? saveData : {};
            //delete saveData['sort_'];
            delete saveData['frontend_sort_'];
            this.saveTableConfigData(saveData);
        });
        // this.page = 1;
        // this.onSortChanges.emit();
    }

    onSortValue(field: any) {
        if (!this.currentSort.has(field.name)) {
            this.currentSort.clear();
            this.currentSort.set(field.name, 1);
        } else {
            const value = this.currentSort.get(field.name);
            this.currentSort.set(field.name, value * -1);
        }
        let sortObject: any = this.mapToObj(this.currentSort);
        if (sortObject.value == '1')
            sortObject.value = 'asc';
        else
            sortObject.value = 'desc';

        if (!this.config.backendSorting) {
            this.sortData(field);
            if (field.composite_sort != undefined && field.composite_sort) {
                sortObject.compositeSort = true;
            }
            sortObject.frontendSorting = true;
            this.onSortChanges.emit(sortObject);
            this.getTableConfig((saveData) => {
                if (saveData) {
                    saveData = (saveData) ? saveData : {};
                    saveData['frontend_sort_'] = sortObject;
                    this.saveTableConfigData(saveData);
                }
            });
        }
        else {
            //below code works for backend sorting
            this.page = 1;
            this.onSortChanges.emit(sortObject);
            this.getTableConfig((saveData) => {
                if (saveData) {
                    saveData = (saveData) ? saveData : {};
                    saveData['sort_'] = sortObject;
                    this.saveTableConfigData(saveData);
                }
            });
        }
    }


    onSort(field) {
        if (field.name && field.name.includes(",")) {
            field.name.split(",").forEach((elem) => {
                field['name'] = elem
                this.onSortValue(field);
            })
        } else {
            this.onSortValue(field);
        }
    }
    mapToObj(inputMap) {
        let obj = { 'value': '', 'key': '' };
        inputMap.forEach(function (value, key) {
            obj['value'] = value;
            obj['key'] = key;
        });
        return obj;
    }


    sortData(field?) {
        try {
            if (this.currentSort.size !== 0) {
                let sortObject = this.mapToObj(this.currentSort);
                try {
                    this.config.FrontDefaultSort = { key: sortObject.key, type: sortObject.value == '1' ? 'asc' : 'desc' };
                } catch (error) { }
                this.items = this.utilService.sortData(JSON.parse(JSON.stringify(this.items)), sortObject, field);
                if (this.sourceItems && Array.isArray(this.sourceItems) && this.sourceItems.length > 0) {
                    try {
                        this.sourceItems = this.utilService.sortData(JSON.parse(JSON.stringify(this.sourceItems)), sortObject, field);
                    } catch (err) {
                        console.error('Failed to sort sourceItems:', err);
                    }
                }
                this.rebuildContextMenuAfterSort();
            }
        } catch (error) {
            console.error("Error while sorting data");
        }
    }
    private rebuildContextMenuAfterSort(): void {
            if (!this.items || !this.items.length) return;

            let configField: any = null;
            for (let field of this.fields) {
                if (field.config && field.config.buttonMenu &&
                    (field.config.type === 'ellipse' || field.config.type === 'button')) {
                    configField = field;
                    break;
                }
            }
        
            if (!configField) return;
        
            this._allowedContextMenu = {};
        
            for (let i = 0; i < this.items.length; i++) {
                if (this.configBasedCapability) {
                    setTimeout(((index: number) => () => {
                        this.items[index]['context_menu'] = this.threeDotsclick(index, this.items[index], configField);
                    })(i));
                } else {
                    this.items[i]['context_menu'] = this.threeDotsclick(i, this.items[i], configField);
                }
            }
    }
    HidetoggleVisibility(event, auto = false) {
        const checked = event;
        this.config.fieldOrder = {};
        this.fields.forEach((item, index) => {
            if (item.name != undefined && item.heading != "" && item.heading) {
                this.config.fieldOrder[item.name] = index;
            }
            if (index == 0) {
                item.disabled = true;//it will raise an error when column reordering
            } else {
                item.disabled = false;
                if (checked && !auto) {
                    item.selected = true;
                    item.hidden = false;
                }
            }
            if (item.hideColumn) {
                item.hidden = true;
                item.selected = false;
            }
            if (item.hidden == undefined) {
                item.hidden = false;
                item.selected = true;
            }
        });
        if (checked === false) {
            this.fields.forEach((item, index) => {
                if (item.heading != '') {
                    if (index == 0) {
                        item.hidden = false;
                        item.selected = true;
                    } else {
                        item.hidden = true;
                        item.selected = false;
                    }
                }
                if (item.name == "gridButton") {
                    item.hidden = false;
                    item.selected = true;
                }
            });
            this.config.viewAll = false;
        } else {
            this.config.viewAll = true;
        }
        if (!auto) {
            this.saveTableConfig();
            this.removeDragListner();
            this.tableInitalized = false;
        }
    }

    toggleVisibility(event, field) {
        field.hidden = !field.hidden;
        const check = event.target.checked;
        if (check === false) {
            field.selected = false;
            this.config.viewAll = false;
        }
        else {
            field.selected = true;
            for (let i = 1; i < this.fields.length; i++) {
                if (this.fields[i].selected == true) {
                    this.flag = true;
                } else {
                    this.flag = false;
                    break;
                }
            }
            if (this.flag) {
                this.config.viewAll = true;
            } else {
                this.config.viewAll = false;
            }
        }
        this.saveTableConfig(field.name);
        this.removeDragListner();
        this.tableInitalized = false;
        this.setProjectionKeys();
        // this.computeColumnPercentages()
    }

    getElHeight(element: any) {
        const elHeight = element.offsetHeight;
        const text = element.innerText;
        if ((elHeight > 50) && (element.innerText.length > 391)) {
            element.innerText = text.substring(0, 392) + '...';
        }
    }

    computeColumnPercentages() {
        const visibleFields = this.fields.filter(f => !f.hidden);
        if (!visibleFields.find(f => f.weight)) {
            return;
        }

        const weightSum = visibleFields
            .map(f => f.weight || 1)
            .reduce((weightSum, currentWeight) => weightSum + currentWeight, 0);

        visibleFields.forEach(f => {
            const weight = f.weight || 1;
            f.width = (weight / weightSum) * 100;
        });
    }

    toggleCol(field) {
        field.hidden = !field.hidden;
        this.computeColumnPercentages();
    }
    socialCalling(action, key) {
        if (action.hasOwnProperty("action_type") && action.action_type == "call")
            window.location.href = `tel://${key[action.key]}`
        else if (action.hasOwnProperty("action_type") && action.action_type == "email")
            window.location.href = `mailto:${key[action.key]}`
        else if (action.hasOwnProperty("action_type") && action.action_type == "whatsApp")
            this.appService.checkNativeApp() ? window.location.href = `whatsapp://send/?phone=${key[action.key]}` : window.location.href = `https://api.whatsapp.com/send?phone=${key[action.key]}`;
        else if (action.hasOwnProperty("action_type") && action.action_type == "social_media") {
            `${key[action.key]}`.includes(":") ? window.location.href = `${key[action.key]}` : window.location.href = `https://${key[action.key]}`
        }
    }

    ngOnDestroy() {
        // this.storageService.removeData('filterConfig', () => { });
        this.ruleEngineService.setRuleArgs(false);
        const data = {
            page: this.page,
            limit: this.limit,
            filter: this.filter,
        };

        //this.sessionService.set(this.currentRoute, data);

        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.subSelected) {
            this.subSelected.unsubscribe();
        }
        if (this.autorefresh['id'] != undefined) {
            clearInterval(this.autorefresh['id']);
        }
        if (this.config.popupModel != undefined) {
            this.config.popupModel.close({});
        }
        this.removeDragListner();
        if (this.changeDetectorRef) {
            this.changeDetectorRef.detach();
        }
        if(this.commonService.visibleFields){
        this.commonService.visibleFields = []
        }
    }

    fetchItems() {
        const params = {
            page: this.page,
            limit: this.limit,
            filter: this.filter,
        };
        params['sort'] = [];
        this.currentSort.forEach((value, key) => {
            let sortKey = key;
            if (this.config && this.config.useDollarPrefixConvention) {
                sortKey = '$' + sortKey;
            }
            params['sort'].push({
                field: sortKey,
                type: value
            });
        });
        this.isLoading = true;
        this.sub.add(this._data
            .subscribe(x => {
                if (x && !x.resource) {
                    this.isItemsExist = false;
                } else if (x && x.resource) {
                    if (this.utilService.isOnlyMobile()) {
                        this.config.activeField = 'tile';
                        this.config.tile = true;
                        this.config.table = false;
                    }
                    if (this.config && this.config.mobile_card_resource && this.utilService.isOnlyMobile()) {
                        this.config.card_selector = "app-mobile-card-view"
                    }
                    if (this.config.card_selector != undefined) {
                        // if (this.config.card_resource == undefined) {
                        //     this.config.tile = false; 
                        //     this.config.activeField = 'table';
                        //     this.config.table = true;
                        // }
                        this.items = [];
                        this.extractData(this.data);
                        setTimeout(() => {
                            this.createCustomCard();
                        })
                    } else {
                        this.extractData(this.data);
                    }

                    if (x && x.count == 0) {
                        this.isItemsExist = false;
                    }
                    //adding for sorting 
                }
            }));
    }
    ngDoCheck() {
        if (this.fields && this.fields[this.fields.length - 1] != undefined && this.fields[this.fields.length - 1].config != undefined && this.fields[this.fields.length - 1].config.type == 'ellipse') {
            this.addTableClass = true;
        }
        if (this.filterFieldGroup != undefined && (this.filterFieldGroup.hasOwnProperty('blocks') ? true : this.filterFieldGroup.length > 0)) {
            //console.log("Filter Group ",this.filterFieldGroup);
            this.formBlock = this.filterFieldGroup.blocks.list.filter;
            if (this.filterFieldGroup.blocks.list.filter != undefined && this.filterFieldGroup.blocks.list.filter.decorator != undefined) {
                this.formBlock['decorator'] = this.filterFieldGroup.blocks.list.filter.decorator;
            }
            //his.filterFieldGroup.blocks.list.filter.banner //this will determine do we have to set bannner for our filter or not 
            this.formBlock['bannerJson'] = this.filterFieldGroup.blocks.list.filter && this.filterFieldGroup.blocks.list.filter.banner != undefined && this.filterFieldGroup.blocks.list.filter.banner && this.config != undefined && this.config.bannerJson != undefined ? this.config.bannerJson : undefined;

        }
    }

    private normalizeSafeHtmlValue(html: any): string {
        if (html === null || html === undefined) {
            return '';
        }
        if (typeof html === 'string') {
            return html;
        }
        if (typeof html === 'object') {
            if ('changingThisBreaksApplicationSecurity' in html) {
                return html.changingThisBreaksApplicationSecurity || '';
            }
            try {
                return JSON.stringify(html);
            } catch {
                return '';
            }
        }
        return String(html);
    }

    getSafeHtml(html: any): SafeHtml {
        const safeString = this.normalizeSafeHtmlValue(html);
        return this.DomSanitizer.bypassSecurityTrustHtml(safeString);
    }

    extractData(body: any) {
        var configField: any = false;
        this.sourceItems = Array.isArray(this.data?.resource) ? JSON.parse(JSON.stringify(this.data.resource)) : [];
        this.items = JSON.parse(JSON.stringify(this.sourceItems));
        if (this.config.noCount != undefined) {
            if (this.config.noCount) {
                this.itemsCount = -1;
            } else {
                this.itemsCount = this.data.count;
            }

        } else {
            this.itemsCount = this.data.count;
        }

        this.config.currentItemCount = this.items.length;
        // if (this.itemsCount != undefined && this.itemsCount) {
        //     this.config.totalPages = Math.ceil(this.itemsCount / 10);
        // }
        // this.showEmptyMessage = this.filter ? false : (this.config && this.config.emptyMessage && this.itemsCount === 0);

        if (this.fields.length) {
            for (let field of this.fields) {
                if (field.config && field.config.buttonMenu && (field.config.type == 'ellipse' || field.config.type == 'button')) {
                    configField = field;
                }
            }
        }

        this.selectedIndices = [];
        this.enableCheckedItems = [];
        if (this.items != null) {
            this.selectedIndices.length = this.items.length;
            this.selectedCount = 0;
            let starTime = new Date().getTime();
            for (let i = 0; i < this.items.length; i++) {
                this.items[i]['_generaterID'] = this.items[i].id || this.baseService.generateID(15);
                this.items[i]['_generatedClass'] = this.getClass(this.items[i]);
                for (let field of this.fields) {
                    delete this.items[i]['mappedValue_' + field.field_id];
                }
                this.getItemFieldClass(this.items[i]);
                if (this.selectedItems != undefined && this.selectedItems.length == 0 && this.config != undefined && this.config.selected_items != undefined && this.config.selected_items.length > 0) {
                    this.selectedItems = JSON.parse(JSON.stringify(this.config.selected_items));//to auto selected items (#137390)
                }
                const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
                if (index > -1) {
                    this.selectedCount++;
                    this.selectedIndices[i] = true;
                    this.selectedItems[index] = this.items[i];
                }
                
                this.restoreSingleFieldSelection(i);

                if (configField && this.items[i]) {
                    if (this.configBasedCapability)
                        setTimeout(() => {
                            this.items[i]['context_menu'] = this.threeDotsclick(i, this.items[i], configField);
                        });
                    else this.items[i]['context_menu'] = this.threeDotsclick(i, this.items[i], configField);
                } else if (this.items[i]) {
                    this.items[i]['context_menu'] = true;
                }

                if (this.bulkActionsConfig && this.bulkActionsConfig.disableIf) {
                    let disableid = eval(this.bulkActionsConfig.disableIf)(this.items[i]);
                    if (disableid != "true" && disableid != true) {
                        this.enableCheckedItems.push(this.items[i]);
                    }
                } else {
                    this.enableCheckedItems.push(this.items[i]);
                }
            }
            let endTime = new Date().getTime();
            console.log("TOTAL TAKEN TIME==>", endTime - starTime)
        }
        if (this.config.activeField == 'tile' && this._cardFields == undefined && this.items != undefined && this.items.length > 0) {
            this.setCardView();
            this.setTopViewForCard()
        }
        this.refreshBulkActionsBar();
        this.cloneItems = JSON.parse(JSON.stringify(this.items));
        let field;
        //setting default frontend setting
        if (this.config.FrontDefaultSort != undefined && this.config.FrontDefaultSort && this.config.FrontDefaultSort.key != undefined && this.fields != undefined && this.fields.length != undefined && this.fields.length > 0) {
            let sortO;
            if ((this.config.FrontDefaultSort.type == 'desc' || this.config.FrontDefaultSort.type == 0)) {
                sortO = -1;
            } else {
                sortO = 1;
            }
            this.currentSort.set(this.config.FrontDefaultSort.key, sortO);
            field = this.fields.find(x => x.name == this.config.FrontDefaultSort.key);
        }

        //for sorting 
        this.sortData(field);
        // this.ngZone.runOutsideAngular(() => {
        //     requestAnimationFrame(() => {
        //         requestAnimationFrame(() => {
        //             const renderEnd = performance.now();
        //             if (this.config.gridExecutionTiming != undefined) {
        //                 this.config.gridExecutionTiming.renderEndTime = renderEnd
        //                 const totalMs = renderEnd - this.config.gridExecutionTiming?.dbResponseTime;
        //                 console.log(`time of ui engine Grid Plot Time → ${Math.round(totalMs)} ms (${(totalMs / 1000).toFixed(4)} s)`);
        //                 this.config.gridExecutionTiming.uiPlotDuration = `${Math.round(totalMs)} ms (${(totalMs / 1000).toFixed(4)} s)`;
        //                 this.config.gridExecutionTiming.totalRecords = this.items.length;
        //         //        this.gridPlotTimeToLocalStorage(this.config.gridExecutionTiming)
        //             } else {
        //                 console.log('time of ui engine Grid Plot Time', this.config.gridExecutionTiming?.dbResponseTime);
        //             }
        //         });
        //     });
        // })
        this.checkIfAiAvailable()
    }

    getItemFieldClass(item) {
        item['without@ndField'] = this.getClass(item);
        this.fields.forEach(field => {
            // dynamic key prefix
            const id = field.field_id;

            // assign dynamic keys on the item

            item[`computedClass_${id}`] = field.cusClass;

            item[`gn_exp_${id}`] = this.getExpression(field, item, 'checkbox_conditions');

            if (field != undefined && field.config != undefined && field.config.route != undefined) {
                item[`build_route_${id}`] = this.buildRoute(field.config.route, item[field.config.key]);
            }
            else {
                item[`build_route_${id}`] = '';
            }

            item[`gn_exp_without_c_c_${id}`] = this.getExpression(field, item);
            item[`custom_class_${id}`] = this.getCustomClass(field);
            item[`gn_class_${id}`] = this.getClass(item, field, `gn_class_${id}`);

            item[`gn_hover_format_${id}`] = this.getExpression(

                field.hover_format,

                field.name_expression ? this.getNameExpression(field.name_expression, item) : item

            );

            item[`gn_dynamic_string_${id}`] = this.baseService.buildDyanamicStr(field.hover_html, {

                data: field.hover_data ? item[field.hover_data] : item,

                type: 'html'

            });

            item[`gn_dynamic_string2_${id}`] = this.baseService.buildDyanamicStr(field.format, {

                data: field.multiRowKey ? item[field.multiRowKey] : item,

                type: 'html'

            });

            item[`gn_NameExpression_${id}`] = this.getNameExpression(field.cssExpression, item);

            item[`gn_timeExpression_${id}`] = this.getExpression(field, item, 'timeExpression');

            item[`hiddenFieldVal_${id}`] = this.getHiddenField(field, item);
            item[`builddynamic_${id}`] = this.baseService.buildDyanamicStr(field.format, { data: field.multiRowKey ? item[field.multiRowKey] : item, type: 'html' })

            item[`mappedValue_${id}`] = this.mapValuePipe.transform(item, field);
            item[`timemappedValue_${id}`] = this.getTimeVal(item[`mappedValue_${id}`]);

            if (field.config && field.config.type === 'dictionary') {
                try {
                    // mimic behavior of "item | mapvalue: field"
                    const mappedValue = this.mapValuePipe.transform(item, field); // you likely have this pipe logic as a method
                    item[`formatted_dictionary_${id}`] = this.getFormattedDictionaryValue(mappedValue, field.name);
                } catch (e) {
                    console.error('Error formatting dictionary value for field', field.name, e);
                    item[`formatted_dictionary_${id}`] = '';
                }
            }
        });

    }



    checkIfAiAvailable(counter = 0) {
        if (this.config?.aiSummary?.configLoaded !== undefined) {
            this.config.aiSummary.load = true;
        } else if (counter < 10) {
            setTimeout(() => this.checkIfAiAvailable(counter + 1), 100);
        } else {
            console.warn("AI summary config not available after 10 retries");
        }
    }

    ngAfterViewChecked() {
        if (!this.tableInitalized && jQuery('.resource_list_' + this.config.resource).length > 0) {
            this.tableInitalized = true;
            this.addDragListner();
        }
        this.updateQuickActionsOverflow();
    }

    // Below 1350px, move Help, Configure Grid, and Logs into the (⋮) overflow menu only when more than 8 . 
    // Keep the existing layout unchanged at 1350px and above, and update dynamically on 
    // icon-count or viewport changes without affecting the count or triggering repeated change detection.
    @HostListener('window:resize')
    updateQuickActionsOverflow() {
        const quickActionCount = this.elementRef.nativeElement.getElementsByClassName('quick-action-icon').length;
        const tooMany = window.innerWidth < 1350 && quickActionCount > 8;
        if (this.tooManyQuickActions !== tooMany) {
            this.tooManyQuickActions = tooMany;
        }
    }


    addDragListner() {
        if (this.config.resource != undefined) {
            jQuery('.resource_list_' + this.config.resource).dragableColumns({
                drag: true,
                dragClass: 'drag',
                overClass: 'over',
                movedContainerSelector: '.dnd-moved',
                onDragEnd: (fromIndex, toIndex) => {
                    this.onColumnDragEnd(fromIndex, toIndex);
                }
            });
        }
    }

    removeDragListner() {
        var cols = jQuery('.resource_list_' + this.config.resource).find('thead tr th');
        [].forEach.call(cols, function (col) {
            jQuery(col).off();
        });
    }


    buildRoute(route: any, value: string, item: any = null) {
        if (typeof route === 'function') {
            return route(value, item);
        }
        const placeholder = '{{key}}';

        if (route.indexOf(placeholder) > -1) {
            route = route.replace(placeholder, value);
        }

        return route;
    }

    checkDisable(item, disableIf: any) {
        let disableval: boolean = false;
        let disableid = eval(disableIf)(item);
        if (disableid == "true" || disableid == true)
            disableval = true;
        return disableval;
    }

    getHoverValue(item, field) {

    }
    // getValue(item: any, field: any) {
    //     // debugger;
    //     var format = field.format;

    //     if (field.type === 'composite' || field.type === 'compositeDate' || field.type === 'compositeDatetime' || field.type === 'compositeTime') {
    //         if (field.template != undefined && this.appService._appData.TEMPLATE_DEF[field.template] != undefined) {
    //             format = this.appService._appData.TEMPLATE_DEF[field.template];
    //             if (field.name != undefined && field.name) {
    //                 item = _.get(item, field.name);
    //             }
    //         }
    //         try {
    //             if (item) {
    //                 return eval(format)(item);
    //             } else {
    //                 return '';
    //             }

    //         } catch (e) {
    //             ;
    //             return '';
    //         }
    //     }
    //     if (field.type === 'array' || field.type == 'timeArray' || field.type == 'dateTimeArray') {
    //         let val = [];
    //         if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
    //             for (let i = 0; i < item[field.name].length; i++) {
    //                 let arrayItem = item[field.name][i];
    //                 let e = eval(format)(arrayItem);
    //                 if (field.type == 'timeArray')
    //                     e = this.utilService.toTimeZoneDateFormat(e, 'time')
    //                 if (field.type == 'dateTimeArray')
    //                     e = this.utilService.toTimeZoneDateFormat(e, 'datetime')
    //                 val.push(e);
    //             }
    //         }
    //         return val;
    //     }
    //     if (field.type == 'advanceText') {
    //         if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
    //             return item[field.name];
    //         }
    //     }
    //     const name = field.name;
    //     let value = null;
    //     if (typeof name == 'function') {
    //         value = name(item);
    //     } else {
    //         if (name.split('.').length > 1) {
    //             const props = name.split('.');
    //             value = item;
    //             for (const v of props) {
    //                 if (value[v]) {
    //                     value = value[v];
    //                 } else {
    //                     value = null;
    //                     break;
    //                 }
    //             }
    //         } else {
    //             if (item) {
    //                 value = item[name];
    //             }
    //         }

    //         if (field.formatter) {
    //             return field.formatter(value, item);
    //         }
    //     }

    //     return value;
    // }

    getFunction(item: any, field: any) {
        let value = null;
        if (typeof field == 'function') {
            value = field(item);
        }
        return value;
    }

    setInnerHtml(value, el) {
        return el.innerHTML = value;
    }

    onClearClicked() {
        this.isChecked = 0;
        this.selectedItems.splice(0, this.selectedItems.length);
        if (this.selectedIndices) {
            this.selectedIndices.splice(0, this.selectedIndices.length);
        }
        this.selectedCount = 0;
        this.page = null;
        setTimeout(() => {
            this.page = 1;
        })
        this.refreshBulkActionsBar();
        if (this.bulkActionsConfig != undefined && this.bulkActionsConfig.type != undefined && this.bulkActionsConfig.type == "multi-form" && this.selectedItems.length == 0)
            this.asideBarService.removeComponent()
    }

    onItemChecked(event: MouseEvent, index: number) {
        this.config.binding = '';
        const checkbox = event.target as HTMLInputElement;
        const checked = checkbox.checked;
        // STOP FLOW WHEN LIMIT REACHED
        if (this.isLimitSelectionReached(checked)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            checkbox.checked = false
            this.selectedIndices[index] = false;
            return;
        }
        this.checkItem(checked, index);
        if (checked) {
            this.isChecked = this.isChecked + 1;
        } else {
            this.isChecked = this.isChecked - 1;
        }
        this.refreshBulkActionsBar(checked);
    }

    checkItem(checked: boolean, index: number) {
        this.selectedIndices[index] = checked;
        const sourceItem = this.getSourceItem(index, this.items[index]);
        if (this.bulkActionsConfig.expression) {
            let elem = sourceItem;
            let key1 = eval(this.bulkActionsConfig.expression);
            let arr = key1.split('.');
            this.bulkActionsConfig.key = arr[1];
        }
        const pos = this.selectedItems.findIndex(i => this.isSameItem(i, sourceItem));

        if (checked) {
            if (pos === -1) {
                this.selectedCount++;
                this.selectedItems.push(this.items[index]);
                try {
                    if (this.items != undefined && this.items[index] != undefined && this.bulkActionsConfig != undefined && this.bulkActionsConfig != "" && this.bulkActionsConfig.format != undefined && this.bulkActionsConfig.format != "") {
                        let calculatedAmount = eval(this.bulkActionsConfig.format)(sourceItem, this.selectedItems);
                        this.evaluatedData = calculatedAmount
                    }
                }
                catch {
                    console.log("error occured while evaluating the expression");
                }
            }
        } else {
            if (pos > -1) {
                this.selectedCount--;
                this.selectedItems.splice(pos, 1);
                try {
                    if (this.items != undefined && this.items[index] != undefined && this.bulkActionsConfig != undefined && this.bulkActionsConfig != "" && this.bulkActionsConfig.format != undefined && this.bulkActionsConfig.format != "") {
                        let calculatedAmount = eval(this.bulkActionsConfig.format)(sourceItem, this.selectedItems);
                        this.evaluatedData = calculatedAmount
                    }
                }
                catch {
                    console.log("error occured while evaluating the expression");
                }
            }
        }
        if (this.bulkActionsConfig.type != undefined && this.bulkActionsConfig.type == "multi-form") {
            this.setAsideForm();
        }
    }

    setAsideForm() {
        this.asideBarService.gridData.next(this.selectedItems);
        var event = {
            resource: this.bulkActionsConfig.resource,
            actionType: {
                "action_name": "ADD"
            },
            data: this.selectedItems,
            decorator: this.bulkActionsConfig.decorator
        }
        let componentConfig = {
            inputs: { data: event }
        };
        let size = this.bulkActionsConfig.size
        if (this.config.sideBarOpen == undefined)
            this.sub.add(this.asideBarService.asideBarClose().subscribe(res => {
                if (this.config.sideBarOpen == true && this.selectedItems.length > 0) {
                    this.onClearClicked()
                }
                this.config.sideBarOpen = res
            }))
        if (this.config.sideBarOpen != true)
            this.sub.add(this.asideBarService.appendComponentTo('aside-modal-container', MultipleFormComponent, componentConfig, size ? size : 'md', this.bulkActionsConfig.label).subscribe(data => {
                this.page = null;
                this.emitDefaultFilter();
                setTimeout(() => {
                    this.page = 1;
                })
            }));
        if (this.selectedItems.length == 0)
            this.asideBarService.removeComponent()
    }

    onAllChecked(checked: boolean) {
        this.config.binding = '';
        if (checked) {
            this.isChecked = this.items.length;
        } else {
            this.isChecked = 0;
            this.page = this.page ? this.page : 1;  // fixed for #129520
            // setTimeout(() => {
            //     this.page = 1;
            // });
        }
        this.items.forEach((item, index) => {
            if (this.bulkActionsConfig && this.bulkActionsConfig.disableIf) {
                let disableid = eval(this.bulkActionsConfig.disableIf)(item);
                if (disableid == "true" || disableid == true) {
                    //if (this.bulkActionsConfig.disableIf && this.bulkActionsConfig.disableIf(item)) {
                    return;
                }
            }
            if (!this.isLimitSelectionReached(checked)) {
                this.checkItem(checked, index);
            }
        });
        this.refreshBulkActionsBar(checked);
        // fixed for #129475
        this.isChecked = this.selectedItems.length > 0 ? this.selectedItems.length : 0;
        console.log('selected count --> ', this.selectedCount);
    }

    private refreshBulkActionsBar(checked?) {
        if (this.bulkActionsConfig != undefined && this.bulkActionsConfig && this.bulkActionsConfig.action) {

            const actions = this.bulkActionsConfig.actions;
            if (actions != undefined) {
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];
                    if (!(this.config && this.config.allowEmptySelection) && this.selectedItems.length === 0) {
                        action.enabled = false;
                    } else {
                        action.enabled = action.show ? action.show(this.selectedItems) : true;
                    }
                }
            }
            let obj = { 'checked': checked };
            this.bulkActionClicked.emit(new BulkActionClickEvent(this.bulkActionsConfig.action, this.selectedItems, this.getSourceItem(0, this.items[0]), this.selectedIndices, obj));
        }
    }

    isSameItem(i1: any, i2: any): boolean {
        const key = this.bulkActionsConfig.key;
        return this.getNestedValue(i1, key) === this.getNestedValue(i2, key);
    }

    /**
     * Restores the checked state of items[index] if it was previously selected
     * via the single-field (checkbox-title) selection mechanism.
     *
     * Matches using both matchKey (for cross-page stability, e.g. marId) AND
     * the unique row id, so that sibling rows sharing the same matchKey value
     * (e.g. multiple dose-time rows of the same medication) are not falsely restored.
     */
    private restoreSingleFieldSelection(index: number): void {
        if (!this.singleFieldSelection?.item?.length) return;

        const matchKey = this.bulkActionsConfig?.matchKey
            ?? this.bulkActionsConfig?.key
            ?? 'id';

        const currentItem = this.items[index];
        const currentItemId = currentItem?.id;
        const currentItemMatchVal = currentItem?.[matchKey];

        const savedIndex = this.singleFieldSelection.item.findIndex(item =>
            item?.[matchKey] === currentItemMatchVal && item?.id === currentItemId
        );

        if (savedIndex > -1) {
            currentItem.checked = true;
            this.singleFieldSelection.item[savedIndex] = currentItem;
        }
    }

    getNestedValue(obj: any, key: string): any {
        if (obj && key) {
            const keys = key.split('.');
            for (const k of keys) {
                obj = obj[k];
            }

            return obj;
        }

    }

    getBulkActionFilterPrintInfo(filterInfo, allPromiseObj) {
        if (this.kxFilter != undefined && this.kxFilter['form'] != undefined && this.kxFilter['form'].form != undefined && this.kxFilter['form'].form.controls != undefined) {
            let controls = this.kxFilter['form'].form.controls;
            Object.keys(controls).forEach(key => {
                //check condition
                let condition_ = controls[key] != undefined && controls[key] && controls[key].value != undefined && controls[key].value && controls[key].question_component != undefined && controls[key].question_component.question != undefined && controls[key].question_component.question.visible != undefined && controls[key].question_component.question.visible && this.kxFilter['filterVal'] != undefined && this.kxFilter['filterVal'] && get_(this.kxFilter['filterVal'], key) ? true : false;

                if (controls[key].question_component == undefined) {
                    return;
                }
                let question = controls[key].question_component.question;

                //this case works for singelselect
                if (condition_ && (controls[key].question_component.question.controlType === "dropdown" || (controls[key].question_component.question.controlType === "searchselect" && controls[key].question_component.question.defaultsetting != undefined && controls[key].question_component.question.defaultsetting.singleSelection != undefined && controls[key].question_component.question.defaultsetting.singleSelection)) && question != undefined && question.options != undefined && question.options.length != undefined) {
                    let currentOption = question.options.find(x => x[question.getterKey] === get_(this.kxFilter['filterVal'], key));
                    if (currentOption) {
                        allPromiseObj.push(this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                            let key_ = res;
                            filterInfo[key_] = currentOption[question.getterValue];
                        }))
                    }
                }

                //this works in case of multiselect
                else if (condition_ && controls[key].question_component.question.controlType == "searchselect" && Array.isArray(get_(this.kxFilter['filterVal'], key)) && get_(this.kxFilter['filterVal'], key).length != undefined && get_(this.kxFilter['filterVal'], key).length > 0) {
                    allPromiseObj.push(this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let val = JSON.parse(JSON.stringify(get_(this.kxFilter['filterVal'], key)));
                        let val_ = val.map(e => e.text).join(",");
                        let key_ = res;
                        filterInfo[key_] = val_;
                    }))
                }
                //all other cases
                else if (condition_ && controls[key].question_component.question.controlType != "hidden" && controls[key].question_component.question.controlType != "monthYearPicker" && controls[key].question_component.question.controlType != "daterangepicker" && controls[key].question_component.question.controlType != "searchselect" && controls[key].question_component.question.controlType != "dropdown") {
                    allPromiseObj.push(this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        filterInfo[key_] = get_(this.kxFilter['filterVal'], key);
                    }))
                }
                else if (condition_ && controls[key].question_component.question.controlType === "daterangepicker") {
                    allPromiseObj.push(this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val && val.FROM != undefined && val.FROM && val.TO != undefined && val.TO && !controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val.FROM, 'date') + " - " + this.utilService.toTimeZoneDateFormat(val.TO, 'date');
                            filterInfo[key_] = modVal;
                        }
                        else if (controls[key].question_component.question.locale != undefined && controls[key].question_component.question.locale.format != undefined && controls[key].question_component.question.outPutFormat != undefined && controls[key].question_component.question.outPutFormat) {
                            filterInfo[key_] = val;
                        }
                        else if (val && controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'date')
                            filterInfo[key_] = modVal;
                        }
                    }))
                } else if (condition_ && controls[key].question_component.question.controlType === "monthYearPicker") {
                    allPromiseObj.push(this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'monthYear');
                            filterInfo[key_] = modVal;
                        }
                    }))
                }
            });
        }
    }

    onBulkActionClicked(action?: any, index?) {
        this.isCountClick = true;
        this.loader.showSpinner();
        let filterInfo: any = {};
        let allPromiseObj: any = [];

        // ******** Decorator Implemented ******** //
        if (this.formBlock.decorator != undefined && this.formBlock.decorator && this.bulkActionsConfig && this.bulkActionsConfig.processBulkAction != undefined && this.bulkActionsConfig.processBulkAction) {
            this.loader.showSpinner();
            if (this.formBlock.decorator && typeof this.formBlock.decorator == "string")
                this.formBlock.decorator = this.baseService.initDecorator(this.formBlock.decorator, this.route, this.injector);

            this.formBlock.decorator.processBulkAction(action, this.selectedItems, this.items, this.selectedIndices, (cb) => {
                if (cb) {
                    // do nothing
                }
                this.loader.hideSpinner();
            });
        }
        // ******** Decorator Implemented ******** //

        if (action) {
            if (action.allow_selection && this.selectedItems.length > action.allow_selection) {
                this.loader.hideSpinner();
                this.alerts.error("Only " + action.allow_selection + " are allowed");
                this.isCountClick = false;
                return
            }
            if (this.selectedItems.length == 0) {
                this.alerts.alert('Please select Items');
                this.loader.hideSpinner();
                this.isCountClick = false;
            } else {
                var actionObj = action;
                if ((actionObj.emit_per_action != undefined && actionObj.emit_per_action) || (actionObj.emit != undefined && actionObj.emit)) {
                    let cloneObj = JSON.parse(JSON.stringify(actionObj));
                    this.bulkActionClicked.emit(new BulkActionClickEvent(cloneObj, this.selectedItems, this.sourceItems, this.selectedIndices));
                    this.isCountClick = false;
                } else if (['print', 'download', 'view_file', 'external_event'].indexOf(actionObj.action) == -1) { //TODO: this needs to be fixed
                    //this.checkBoxActions(actionObj, this.selectedItems, 'bulk');
                    if (actionObj.min_length != undefined && actionObj.min_length && (this.selectedItems.length <= actionObj.min_length)) {
                        this.alerts.error(actionObj.error_msg);
                        this.isCountClick = false;
                        this.loader.hideSpinner();
                    }
                    if (actionObj != undefined && actionObj.templateInterceptor != undefined && actionObj?.templateInterceptor?.datasource) {
                        this.checkTemplates(this.selectedItems, actionObj ,'bulk');
                    }
                    else {
                        this.checkBoxActions(actionObj, this.selectedItems, 'bulk');
                    }
                }
                else {
                    let cloneObj = JSON.parse(JSON.stringify(actionObj));
                    if (cloneObj && cloneObj.isUserPrint != undefined && cloneObj.isUserPrint == true) {
                        // this.prePrint(cloneObj, this.selectedItems, index, "", (data) => {
                        //     // this.bulkActionClicked.emit(new BulkActionClickEvent(cloneObj, this.selectedItems));
                        // });
                        try {
                            console.log("Inside bulkaction PTS Condition");
                            this.utilService.performPreprintAction(
                                this.baseService,
                                cloneObj,
                                (res: any) => this.prePrint(cloneObj, this.selectedItems, index, "", res, (data) => { }),
                                (res: any) => this.emitAction(this.selectedItems, cloneObj, index, "")
                            );
                        } catch (err) {
                            console.error("Unexpected error in match block:", err);
                            this.prePrint(cloneObj, this.selectedItems, index, "", (data) => { });
                        }
                    }
                    else {
                        //This function will set filterPrintInfo for BulkAction case
                        this.getBulkActionFilterPrintInfo(filterInfo, allPromiseObj);
                        Promise.all(allPromiseObj).then(promiseResponse => {
                            if (cloneObj != undefined && cloneObj.file_data != undefined) {
                                cloneObj.file_data['filterPrintInfo'] = Object.keys(filterInfo).length ? filterInfo : false;
                            }
                            this.bulkActionClicked.emit(new BulkActionClickEvent(cloneObj, this.selectedItems));
                        });

                    }
                    this.isCountClick = false;
                }
            }
        }
        setTimeout(() => {
            if (!this.loader.stophideSpinner_)
                this.loader.hideSpinner();
        });
    }


    downloadArchive() {
        var filterObj: any = this.kxFilter;
        var data = {
            action: "download",
            file_data: { file_type: 'xlsx', actionType: 'downloadCSV', download_only: true }
        }
        if (filterObj != undefined && filterObj.form != undefined && filterObj.form.isFormValid()) {

            this.sendButtonData(data);
        } else {
            if (filterObj == undefined || filterObj.form == undefined) {
                this.sendButtonData(data);
            } else {
                this.alerts.error("selfilter")
            }
        }

    }
    onButtonClicked(data, $event?) {
        if (data.action == 'download') {
            let popobj = { title: 'Download', size: DialogModalSize.Sm, popupConfig: this.config.archiveConfig };
            this.dialogService.open(DownloadPopupComponent, popobj).afterClosed.subscribe(
                response => {
                    if (response) {
                        if (data.file_data) {
                            delete data.file_data.isCurrentXls;
                        }
                        if (typeof response == "object" && response.archiveConfig != undefined) {
                            this.setArchivePolicy(response.archiveConfig);
                        } else if (typeof response == "object" && response.chunk_download != undefined) {
                            var newData = JSON.parse(JSON.stringify(data));
                            newData.file_data.actionType = response.type;
                            newData.file_data.chunk_download = true;
                            if (response.chunk_size != undefined) {
                                newData.file_data.chunk_size = response.chunk_size;
                            }
                            this.sendButtonData(newData);
                        } else {
                            if(typeof response == "object"){
                               data.file_data.actionType = response.type;
                               if(response != undefined && response.isCurrentXls!= undefined && response.isCurrentXls){
                                   data.file_data.isCurrentXls = true;
                                  }
                            }else {
                              data.file_data.actionType = response;
                             }
                              this.sendButtonData(data);
                       }
                    }
                });
            // this.smartModalService.open(DownloadPopupComponent, '', 'Download', ModalSize.Sm).subscribe(res => {
            //     if(res && res.result){
            //         data.file_data.actionType = res.result;
            //         this.sendButtonData(data);
            //     }
            // else{
            //     data.file_data.actionType = res.result;
            //     this.sendButtonData(data);
            // }
            // }, err => {
            //     console.log("err");
            // });
        } else if (['print', 'print-async', 'download', 'view_file'].indexOf(data.action) > -1) {
            if (data.action == "print") {
                if (this.config && this.config.printActions != undefined && this.config.printActions.length > 0) {
                    this.sendButtonData(data, false, $event);
                }
                else {
                    data.isGrid = true;
                    // this.prePrint(data, "", "", $event);
                    try {
                        console.log("Inside onButtonClicked PTS Condition");
                        let templateId = data?.file_data?.template;
                        if (!templateId && data?.isGrid && data.isGrid == true) {
                            templateId = "grid";
                        }
                        this.utilService.performPreprintAction(
                            this.baseService,
                            data,
                            (res: any) => this.prePrint(data, "", "", $event, res),
                            (res: any) => this.sendButtonData(data, false, $event),
                            templateId
                        )
                    } catch (err) {
                        console.error("Unexpected error in match block:", err);
                        this.prePrint(data, "", "", $event);
                    }
                }
            }
            else {
                if (this.config.printAll != undefined && this.config.printAll) {
                    let popobj = { title: 'Print', size: DialogModalSize.Sm };
                    this.dialogService.open(PrintPopupComponent, popobj).afterClosed.subscribe(
                        response => {
                            console.log(response)
                            if (response && response.type == "print_all") {
                                var downloadObj: any = false;
                                if (this.config.custom_button != undefined && Array.isArray(this.config.custom_button)) {
                                    for (let index = 0; index < this.config.custom_button.length; index++) {
                                        const element = this.config.custom_button[index];
                                        if (element.action != undefined && element.action == "print") {
                                            downloadObj = JSON.parse(JSON.stringify(element));
                                            break;
                                        }

                                    }
                                }
                                if (downloadObj) {
                                    downloadObj.file_data.actionType = "downloadCSV"
                                    downloadObj.file_data.type = data.action
                                    downloadObj.file_data.page_size = response.print
                                    this.sendButtonData(downloadObj, false, $event);
                                } else {
                                    this.sendButtonData(data, false, $event);
                                }
                            } else if (response != undefined) {
                                this.sendButtonData(data, false, $event);
                            }
                        });
                } else {
                    this.sendButtonData(data, false, $event);
                }

            }
        } else {
            this.editEllipseClick.emit({ 'actionType': data, projectionkeys: this.config['projection_keys'] != undefined ? this.config['projection_keys'] : null });
            //TODO
        }

    }

    checkBannerExpression(expression, item): boolean {
        let flag = true;
        try {
            if (expression != undefined) {
                flag = eval(expression);
            }
        } catch (error) { }
        return flag;
    }

    sendButtonData(data, callback: any = false, $event?) {
        data.file_data.action = data.action;
        if (data.action == "print") {
            if (data.file_data.csvprint == null)
                data.file_data.actionType = "download";
        }
        if (data.file_data != undefined) {
            var argData = { page_size: this.limit, page_no: this.page };
            if (data.file_data.args != undefined && data.file_data.args != "") {
                data.file_data.args = this.baseService.buildDyanamicStr(data.file_data.args, { data: argData });
            }
            if (data.file_data.template == undefined || (data.file_data.print_data != undefined && data.file_data.print_data == "grid")) {
                if (this.fields.length > 0) {
                    let gridInfo: any = [];
                    let bannerInfo = [];
                    let filterInfo: any = {};
                    var fieldsClone = JSON.parse(JSON.stringify(this.fields));
                    let allPromiseObj: any = [];
                    let allPromiseBannerObj: any = [];
                    var i = 0;
                    for (let singleField of fieldsClone) {
                        if (!singleField.hidden) {
                            i++;
                            allPromiseObj.push(this.baseService.asyncLanguageProcess(singleField.heading));
                            var itemObj = {
                                heading: singleField.heading,
                                type: (singleField.type != undefined) ? singleField.type : "string",
                                value: (singleField.value != undefined) ? singleField.value : '',
                                name: singleField.name,
                                name_expression: singleField.name_expression ? singleField.name_expression : "",
                                isFrontend: singleField.isFrontend ? singleField.isFrontend : false,
                                format: (singleField.format != undefined) ? btoa(singleField.format) : "",
                                print_format: (singleField.print_format != undefined) ? btoa(singleField.print_format) : "",
                                class_conditions: (singleField.class_conditions != undefined) ? btoa(JSON.stringify(singleField.class_conditions)) : "",
                                map: (singleField.map != undefined) ? btoa(JSON.stringify(singleField.map)) : "",
                                getterArrayKey: singleField.getterArrayKey ? singleField.getterArrayKey : '', //for special array type, basically dynamic header
                                getterValue: singleField.getterValue != undefined && singleField.getterValue ? singleField.getterValue : '',
                                getterKey: singleField.getterKey != undefined && singleField.getterValue ? singleField.getterKey : ''
                            };


                            if (itemObj.type == "specialArray" && singleField.setterKey != undefined) {
                                itemObj["setterKey"] = singleField.setterKey;
                            }
                            gridInfo.push(itemObj);
                        }
                    }
                    if (this.config.showBanner != undefined && this.config.showBanner && this.commonService.bannerInfo != undefined && this.commonService.bannerInfo.bannerObj != undefined && this.commonService.bannerInfo.bannerObj.jsonFields != undefined && this.commonService.bannerInfo.bannerObj.jsonFields.fields != undefined) {
                        let bannerFieldClone = JSON.parse(JSON.stringify(this.commonService.bannerInfo.bannerObj.jsonFields.fields));
                        let val = this.commonService.bannerInfo.val;
                        for (let singleField of bannerFieldClone) {
                            if (!singleField.hidden && this.checkBannerExpression(singleField.expression, val)) {
                                if (singleField.format != undefined) {
                                    var formatted = '';
                                    let fn; // Dont remove it, used for format when arrow fn is removed
                                    if (this.utilService.checkExpression(singleField, val))
                                        formatted = eval(singleField.format)(val);
                                }
                                allPromiseBannerObj.push(this.baseService.asyncLanguageProcess(singleField.heading));
                                if (formatted != '' || val[singleField.name] != '') {
                                    bannerInfo.push({
                                        heading: singleField.heading,
                                        type: (singleField.type != undefined) ? singleField.type : "string",
                                        value: (singleField.format != undefined) ? formatted : (val[singleField.name] != undefined ? val[singleField.name] : ''),
                                        name: singleField.name,
                                        isFrontend: singleField.isFrontend ? singleField.isFrontend : false,
                                        format: (singleField.format != undefined) ? btoa(singleField.format) : "",
                                        class_conditions: (singleField.class_conditions != undefined) ? btoa(JSON.stringify(singleField.class_conditions)) : "",
                                        map: (btoa(JSON.stringify(singleField.map)) != undefined) ? singleField.map : ""
                                    })
                                }
                            }
                        }
                        Promise.all(allPromiseBannerObj).then(promiseResponse => {
                            if (bannerInfo && bannerInfo.length > 0) {
                                for (let i in bannerInfo) {
                                    bannerInfo[i].heading = promiseResponse[i];
                                }
                            }
                        })
                        data.file_data.bannerInfo = bannerInfo.length ? bannerInfo : false;
                        data.file_data.bannerData = val;
                    }
                    //this works to set value of filters
                    if (this.kxFilter != undefined && this.kxFilter['form'] != undefined && this.kxFilter['form'].form != undefined && this.kxFilter['form'].form.controls != undefined) {
                        let controls = this.kxFilter['form'].form.controls;
                        Object.keys(controls).forEach(key => {
                            //check condition
                            let condition_ = controls[key] != undefined && controls[key] && controls[key].value != undefined && controls[key].value && controls[key].question_component != undefined && controls[key].question_component.question != undefined && controls[key].question_component.question.visible != undefined && controls[key].question_component.question.visible && this.kxFilter['filterVal'] != undefined && this.kxFilter['filterVal'] && get_(this.kxFilter['filterVal'], key) ? true : false;

                            if (controls[key].question_component == undefined) {
                                return;
                            }
                            let question = controls[key].question_component.question;

                            //this case works for singelselect
                            if (condition_ && (controls[key].question_component.question.controlType === "dropdown" || (controls[key].question_component.question.controlType === "searchselect" && controls[key].question_component.question.defaultsetting != undefined && controls[key].question_component.question.defaultsetting.singleSelection != undefined && controls[key].question_component.question.defaultsetting.singleSelection)) && question != undefined && question.options != undefined && question.options.length != undefined) {
                                let currentOption = question.options.find(x => x[question.getterKey] === get_(this.kxFilter['filterVal'], key));
                                if (currentOption) {
                                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                                        let key_ = res;
                                        filterInfo[key_] = currentOption[question.getterValue];
                                    })
                                }
                            }

                            //this works in case of multiselect
                            else if (condition_ && controls[key].question_component.question.controlType == "searchselect" && Array.isArray(get_(this.kxFilter['filterVal'], key)) && get_(this.kxFilter['filterVal'], key).length != undefined && get_(this.kxFilter['filterVal'], key).length > 0) {
                                this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                                    let valO = get_(this.kxFilter['filterVal'], key);
                                    controls[key].setValue(valO);
                                    let val = JSON.parse(JSON.stringify(valO));
                                    let val_ = val.map(e => e.text).join(",");
                                    let key_ = res;
                                    filterInfo[key_] = val_;
                                })
                            }
                            //all other cases
                            else if (condition_ && controls[key].question_component.question.controlType != "hidden" && controls[key].question_component.question.controlType != "monthYearPicker" && controls[key].question_component.question.controlType != "daterangepicker" && controls[key].question_component.question.controlType != "searchselect" && controls[key].question_component.question.controlType != "dropdown") {
                                this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                                    let key_ = res;
                                    filterInfo[key_] = get_(this.kxFilter['filterVal'], key);
                                })
                            }
                            else if (condition_ && controls[key].question_component.question.controlType === "daterangepicker") {
                                this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                                    let key_ = res;
                                    let val = get_(this.kxFilter['filterVal'], key);
                                    if (val && val.FROM != undefined && val.FROM && val.TO != undefined && val.TO && !controls[key].question_component.question.singleDatePicker) {
                                        let modVal = this.utilService.toTimeZoneDateFormat(val.FROM, 'date') + " - " + this.utilService.toTimeZoneDateFormat(val.TO, 'date');
                                        filterInfo[key_] = modVal;
                                    }
                                    else if (controls[key].question_component.question.locale != undefined && controls[key].question_component.question.locale.format != undefined && controls[key].question_component.question.outPutFormat != undefined && controls[key].question_component.question.outPutFormat) {
                                        filterInfo[key_] = val;
                                    }
                                    else if (val && controls[key].question_component.question.singleDatePicker) {
                                        let modVal = this.utilService.toTimeZoneDateFormat(val, 'date')
                                        filterInfo[key_] = modVal;
                                    }
                                })
                            } else if (condition_ && controls[key].question_component.question.controlType === "monthYearPicker") {
                                this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                                    let key_ = res;
                                    let val = get_(this.kxFilter['filterVal'], key);
                                    if (val) {
                                        let modVal = this.utilService.toTimeZoneDateFormat(val, 'monthYear');
                                        filterInfo[key_] = modVal;
                                    }
                                })
                            }
                        });

                        if (data.noComplexSearch == undefined) {
                            //support for complex search
                            if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined && this.gridPrintFlag) {
                                this.baseService.asyncLanguageProcess(this.complexSearchRef.config.searchField.label).then((res: any) => {
                                    if (this.complexSearchRef.finalFilterVal != undefined && this.complexSearchRef.finalFilterVal) {
                                        let obj = {};
                                        obj[res] = this.complexSearchRef.finalFilterVal;
                                        filterInfo = { ...filterInfo, ...obj };
                                    }
                                });
                                // let complexSearch = {}

                            } else if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined && !this.gridPrintFlag) {
                                filterInfo = { ...filterInfo };
                            }
                        }

                    }

                    if (this.appService.getUniversalConfig("multi_care_type") && this.filterFieldGroup && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.config && this.filterFieldGroup.blocks.config.care_type && this.filterFieldGroup.blocks.config.care_type.header && data.action == "download") {
                        let obj = {}; let filter_key = "Care Type";
                        let value = this.appService.getDynamicFunctions("getCurrentCareTypeName")
                        obj[filter_key] = value;
                        filterInfo = { ...filterInfo, ...obj };
                    }

                    //************** filter end*/ 
                    Promise.all(allPromiseObj).then(promiseResponse => {
                        for (let i in gridInfo) {
                            gridInfo[i].heading = promiseResponse[i];
                        }
                        if (data != undefined && data.file_data != undefined) {
                            data.file_data['filterPrintInfo'] = Object.keys(filterInfo).length ? filterInfo : false;
                        }
                        data.file_data.gridInfo = gridInfo;
                        data.file_data.secondaryUhidKey = this.config && this.config.secondary_uhid_default ? true : false
                        data.file_data.ehrViewKey = this.config && this.config.ehr_view_default ? true : false
                        if (this.filterFormGroup && this.filterFormGroup.value != undefined && this.filterFormMapping) {
                            this.buildLabelFromMapping(this.baseService.cleanObject(JSON.parse(JSON.stringify(this.filterFormGroup.value))), this.filterFormMapping, (filterInfo) => {
                                if (filterInfo && Object.keys(filterInfo).length) {
                                    data.file_data.filterInfo = filterInfo;
                                } else {
                                    delete data.file_data.filterInfo;
                                }
                                if (!callback) {
                                    this.bulkActionClicked.emit(new BulkActionClickEvent(data.action, data, null, null, this.config['projection_keys'] != undefined ? this.config['projection_keys'] : null, $event));
                                } else {
                                    return callback(data);
                                }

                            });
                        } else {
                            if (!callback) {
                                this.bulkActionClicked.emit(new BulkActionClickEvent(data.action, data, null, null, this.config['projection_keys'] != undefined ? this.config['projection_keys'] : null, $event));
                            } else {
                                return callback(data);
                            }
                        }

                    });
                }
            } else {
                if (!callback) {
                    this.bulkActionClicked.emit(new BulkActionClickEvent(data.action, data, null, null, this.config['projection_keys'] != undefined ? this.config['projection_keys'] : null));
                } else {
                    return callback(data);
                }
            }
        }
    }

    buildLabelFromMapping(data, mapping, callback) {
        if (Object.keys(data).length) {
            try {
                var allPromiseObj = [];
                var finalData = {};
                let dataInfo = [];
                for (let key in data) {
                    if (mapping[key] != undefined && mapping[key]["label"] != undefined && mapping[key]["label"] != "") {
                        allPromiseObj.push(this.baseService.asyncLanguageProcess(mapping[key]["label"]));
                        dataInfo.push(key);
                    }
                }
                Promise.all(allPromiseObj).then((promiseResponse) => {
                    for (let i in dataInfo) {
                        finalData[dataInfo[i]] = promiseResponse[i];
                    }
                    callback(finalData);
                }).catch(() => {
                    callback({});
                });
            } catch (e) {
                callback({});
            }
        } else {
            callback({});
        }
    }

    convertString(obj: any) {
        return JSON.stringify(obj);
    }
    checkBoxActions(action: any, val: any, actiontype?: any) {
        const originalVal = this.getOriginalValue(val);
        if (action.selector != undefined) {
            let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
            let obj = {
                data: {
                    "selector": action.selector,
                    "item": JSON.parse(JSON.stringify(originalVal)),
                    "action": action,
                    "ehr_view_default": this.config && this.config.ehr_view_default ? this.config.ehr_view_default : false
                },
                title: action.popup.title,
                size: action.popup.size
            }
            if (action && action.title) {
                obj['title'] = action.title;
            }
            let path = this.router;
            this.isCountClick = false;
            this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => {
                this.bannerRefreshClick.emit("");
                this.onButtonClicked({
                    "action": "refresh",
                    "label": "field.label.refresh",
                    "class": "fa fa-refresh",
                    "permission_required": false
                })
                if (action.hasOwnProperty('redirect')) {
                    if (path.url.includes('?')) {
                        if (path.url.split('?')[0] == action.redirect) {
                            let url = this.router.url;
                            this.router.navigate(["/search"]).then(() => {
                                this.router.navigateByUrl(url);
                            });
                        }
                    }
                }
                else if (action.popup && action.popup.redirectLink && res && res.resource && res.resource.length > 0) {
                    this.editEllipseClick.emit({ data: res.resource[0], 'actionType': action['popup'] })
                }
                else if (action.refersh_grid) {
                    this.emitDefaultFilter();
                    this.clearBulkActionItems();
                }
                //window.location.reload() 
            },
                err => { console.log("err"); });
            // let obj = {
            //     "selector": action.selector,
            //     "item": val,
            //     "action": action
            // }
            // let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
            // this.smartModalService.open(DynamicPopUpComponent, obj, action.popup.title, size).subscribe(res => {

            // }, err => {
            //     console.log("err");
            // }
            // );
        }
        else if (action != undefined && action.emitAction != undefined && action.emitAction) {
            this.checkboxaction.emit({ selectedItems: originalVal, action: action });
            this.isCountClick = false;
        }
        else {
            // obj.actionType = 'bulk';
            let obj: any = Object.assign({ action }, { val: originalVal });
            if (obj.action.form) {
                if (actiontype) {
                    obj.actiontype = 'bulk'; // This is settings for bulk action
                }
                let size = this.baseService.getModalSize(action['popup'] && action['popup']['size'] ? action['popup']['size'] : 'lg');
                this.smartModalService.open(DynamicPopUpComponent, obj, obj.action.title, size).pipe(take(1)).subscribe(res => {
                    if (res) {
                        if (this.filterFieldGroup == undefined || (this.filterFieldGroup != undefined && this.filterFieldGroup.blocks.list.filter.default_filter == undefined))
                            this.emitDefaultFilter();
                        else {
                            this.isChecked = 1;
                        }
                        setTimeout(() => {
                            this.clearBulkActionItems();
                            if (obj.action.auto_refresh != false) {
                                this.onButtonClicked({
                                    "action": "refresh",
                                    "label": "field.label.refresh",
                                    "class": "fa fa-refresh",
                                    "permission_required": false
                                });
                            }
                        })
                    }
                },
                    err => {
                        console.log("err");
                    }
                );
                this.isCountClick = false;
            }
            else {
                let val: any; let getterKey; let getterValue: any
                if (obj.action != undefined && obj.action.file_data != undefined && obj.action.file_data.cumulativeInfo != undefined) {
                    val = obj.val;
                } else if (obj.action && obj.action.type && obj.action.type == "arrayobject") {
                    getterKey = action.getterKey != undefined && action.getterKey ? action.getterKey : 'id';
                    getterValue = action.getterValue != undefined && action.getterValue ? action.getterValue : this.bulkActionsConfig.key;
                    let value = obj.val.map((y: any) => {
                        let extractedValue = {};
                        getterValue.split(",").forEach(elem => {
                            extractedValue[elem] = y[elem]
                        })
                        if (action?.extra_key) {
                            if (action?.extra_key) {
                                if (action?.extra_key) {
                                    Object.entries(action.keytosend).forEach(([key, value]) => {
                                        if (typeof value === 'string' && value in y) {
                                            extractedValue[key] = y[value];
                                        }
                                    });
                                }
                            }
                        }
                        return extractedValue
                    })
                    val = {};
                    val[getterKey] = value
                } else {
                    getterKey = action.getterKey != undefined && action.getterKey ? action.getterKey : 'id';
                    getterValue = action.getterValue != undefined && action.getterValue ? action.getterValue : this.bulkActionsConfig.key;
                    let id_ = this.getId(obj.val, getterValue);
                    let id = action.type != undefined && action.type === "array" ? id_.split(",") : id_;
                    val = {};
                    val[getterKey] = id;
                    this.setbulkExtrakeys(action, val, obj);
                }
                var args = "";
                if (obj.action != undefined && obj.action.args != undefined) {
                    args = obj.action.args;
                }
                this.baseService.action(val, obj.action.action, obj.action.application, obj.action.resource, "", "", args).subscribe(
                    (data: any) => {
                        if (data.errCode == -1) {
                            if (data.message)
                                this.alerts.error(data.message);
                            else
                                this.alerts.error('API error');
                            if (action.redirect && this.filterFieldGroup.blocks.list.filter.default_filter != undefined)
                                this.emitDefaultFilter();
                            if (this.filterFieldGroup?.blocks?.list?.filter?.default_filter == undefined) {
                                this.emitDefaultFilter();
                            }
                            if (this.filterFieldGroup?.blocks?.list?.bulkAction && this.filterFieldGroup?.blocks?.list?.bulkAction?.actions[0] != undefined && this.filterFieldGroup.blocks.list.bulkAction.actions[0].gridrefreshaftererror)
                                this.onButtonClicked({
                                    "action": "refresh",
                                    "label": "field.label.refresh",
                                    "class": "fa fa-refresh",
                                    "permission_required": false
                                });
                            this.clearBulkActionItems();
                        } else {
                            if (obj && obj.action && obj.action.printValue) {
                                if (obj.action.printKey) {
                                    try {
                                        let s = JSON.parse(atob(data.resource[0][obj.action.printKey].split(",")[1]));
                                        this.loader.hideSpinner();
                                        if (s.errCode === -1) {
                                            this.alerts.error(s.message);
                                        }
                                        return
                                    } catch {
                                        // return
                                    }
                                }
                                this.baseService.printFile(this.baseService.base64ToArrayBuffer(data.resource[0][obj.action.printKey]), "application/pdf", "");
                            }
                            if (data.errCode == 0) {
                                // opt-in per action: e.g. an action that only starts background work says so instead of the generic toast.
                                // alerts.success() ignores its text (always "Request Successful"), so a custom message needs successWithMessage
                                if (obj?.action?.success_message) {
                                    this.alerts.successWithMessage("", obj.action.success_message);
                                } else {
                                    this.alerts.success(obj.val.length + " " + obj.action.action + " Successfully");
                                }
                            }
                            if (obj?.action?.redirectUrl) {
                                let url = this.route.queryParams['_value'].returnUrl;
                                this.router.navigateByUrl(url);
                            }
                            if (this.filterFieldGroup != undefined && this.filterFieldGroup.blocks != undefined && this.filterFieldGroup.blocks.list != undefined && this.filterFieldGroup.blocks.list.filter != undefined && this.filterFieldGroup.blocks.list.filter.default_filter == undefined) {
                                this.emitDefaultFilter();
                            } else {
                                if (obj.action.refresh != undefined && obj.action.refresh) {
                                  //  this.emitDefaultFilter();
                                    this.onClearClicked();
                                }
                            }

                            this.clearBulkActionItems();
                            this.onButtonClicked({
                                "action": "refresh",
                                "label": "field.label.refresh",
                                "class": "fa fa-refresh",
                                "permission_required": false
                            });

                        }
                        this.loader.hideSpinner();
                    }, error => {
                        console.log(error);
                        this.loader.hideSpinner();
                        this.alerts.error('API error');
                    }
                )
            }
        }
    }
    clearBulkActionItems() {
        this.selectedItems = [];
        this.selectedIndices = [];
        this.selectedCount = 0;
        this.isChecked = 0;
        this.isCountClick = false;
        document.querySelectorAll('.checkbox').forEach((el: any) => { el.checked = false;}); // force checkbox reset
    }

    showDocument(itemObj, field) {
        var item = itemObj[field.fieldName ? field.fieldName : field.name];
        let obj = { data: { id: item }, title: 'View Document', size: DialogModalSize.Lg };
        this.dialogService.open(ShowPdfComponent, obj).afterClosed.subscribe(
            response => {

            }
        );
    }
    openJsonViewer(item, field) {
        var val = this.mapValuePipe.transform(item, field);
        if (val == undefined || val == "") {
            val = "{}";
        }
        var jsonContent = val;
        try {
            jsonContent = typeof val === 'string' ? JSON.parse(val) : val;
        } catch (e) {
            // If parsing fails, sanitize the string by removing newlines and quotes for safe display.
            jsonContent = jsonContent.replace(/\n/g, ' ').replace(/"/g, ' ');
        }
        this.dialogService.open(JsonViewerComponent, { data: jsonContent }).afterClosed.subscribe(
            response => {

            }
        );
    }
    getId(val, key) {
        let id = "";
        for (let i = 0; i < val.length; i++) {
            if (val.length == i) {
                id = id;
            }
            else {
                if (i == 0) {
                    id = val[i][key];

                }
                else {
                    id = id + "," + val[i][key];
                }
            }
        }
        return id;
    }
    onActionClicked(item: any, action: any) {
        //this.actionClicked.emit(new ActionClickEvent(action.name, item));
    }

    onActionChange(event: any, item: any) {
        //     const action = event.target.value;
        //     this.actionClicked.emit(new ActionClickEvent(action, item));
    }

    onActionCheckbox(event: any, item: any, action: any) {
        this.singleFieldSelection = this.singleFieldSelection == undefined ? {} : this.singleFieldSelection;
        this.singleFieldSelection.item = this.singleFieldSelection.item == undefined ? [] : this.singleFieldSelection.item;
        if (event.target.checked && action.checked == 'singleSelected') {
            item.checked = true;
            if (!this.singleFieldSelection.item.some(x => x.id === item.id)) {
                this.singleFieldSelection.item = [...this.singleFieldSelection.item, item];  // Use spread to avoid direct mutation
            }
        } else if (!event.target.checked && action.unchecked == 'singleDiselected') {
            item.checked = false;
            this.singleFieldSelection.item = this.singleFieldSelection.item.filter(x => x.id !== item.id);
        } else if (Array.isArray(item)) {
            let arr = [];
            item.forEach(element => {
                element.checked = event.target.checked;
                if (event.target.checked) {
                    let val = this.getExpression(action, element, 'checkbox_conditions');
                    if (val) {
                        arr.push(element);
                    }
                }
            });
            this.singleFieldSelection.item = event.target.checked ? [...arr] : [];
        }
        this.singleFieldSelection = { event: event, action: action, item: this.singleFieldSelection.item };
    }

    onSingleActionClicked(data) {
        this.actionClicked.emit(data);
        setTimeout(() => {
            this.selectedAllCheckbox.nativeElement.checked = false;
            this.singleFieldSelection.item = undefined;
        })
    }

    extraButtonAction(event, data) {
        this.actionClicked.emit({ event: event, data: data });
    }

    shouldShow(item: any, action: any): boolean {
        return action.show ? action.show(item) : true;
    }

    public getFormattedDictionaryValue(val, key) {
        return this.utilService.getFormattedDictionaryValue(val, key);
    }

    // checkBoxActions
    openVideoPopup(action: any, item: any) {
        if (action && item) {
            let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
            let obj = {
                data: {
                    "item": item,
                    "action": action
                },
                title: action.popup.title,
                size: action.popup.size
            }
            this.dialogService.open(VideoPlayerComponent, obj).afterClosed.subscribe(res => {
                if (res) {

                }
            },
                err => {
                    console.error("Error in getting data ", err);
                })
        }
    }

    // checkActionCondition(item: any, value: string) {
    //     const field = {
    //         'name': value
    //     };
    //     const result = this.utilService.getValue(item, field);
    //     if (result) {
    //         this.showActionSpan = true;
    //         return value;
    //     } else {
    //         return null;
    //     }

    // }
    private checkIfDisabled(action: any, item: any) {
        if (action && action.disabled) {
            return action.disabled(item);
        } else {
            return false;
        }
    }

    private onClearMultiSort(action: any) {
        this.currentSort.clear();
        this.fetchItems();
    }

    private applyDefaultSorting(event?) {
        var defaultSorted = this.config.default_sorted.split(":");
        const f = this.fields.find(field => field.name.toLowerCase() === defaultSorted[0].toLowerCase());
        if (f) {
            this.page = 1;
            if (event != undefined) {
                if (defaultSorted[1] == undefined) {
                    this.currentSort.set(f.name, -1);
                    this.onSortChanges.emit({ form: event, key: f.name, value: 'desc' });
                } else {
                    this.currentSort.set(f.name, (defaultSorted[1] == 'asc') ? 1 : -1);
                    this.onSortChanges.emit({ form: event, key: f.name, value: defaultSorted[1] });
                }
            }
            else {
                if (defaultSorted[1] == undefined) {
                    this.currentSort.set(f.name, -1);
                    this.onSortChanges.emit({ key: f.name, value: 'desc' });
                } else {
                    this.currentSort.set(f.name, (defaultSorted[1] == 'asc') ? 1 : -1);
                    this.onSortChanges.emit({ key: f.name, value: defaultSorted[1] });
                }
            }
        }
    }
    private ratingChanged(event: any) {
    }

    private calculateMargins(element: any): number {
        const regExpr = new RegExp('col-md', 'i');
        const classChildren = jQuery(element)
            .children();
        if (0 === classChildren.length) {
            return 0;
        }
        const classes = classChildren
            .attr('class')
            .split(' ')
            .filter(x => regExpr.test(x));
        if (classes.length === 0) {
            return 0;
        }
        return parseInt(classes[0].split('-')[2], 10);
    }

    dateToString(date: any) {
        return this.utilService.dateToString(date);
    }

    getTimeVal(date: any) {
        return this.utilService.getTimeVal(date);
    }

    // goToOtherApplication(app, route) {
    //     this.patientRegistration.emit('register');
    // }
    //added by abhinav chauhan on 14-feb-2020
    threeDotsclick(index, item?, field?) {
        var finalResult = false;
        var result: any = {};
        this._allowedContextMenu[index] = {};
        if (item != undefined && field != undefined && field.config != undefined && field.config.buttonMenu != undefined && field.config.buttonMenu.length > 0) {
            item["__user_type"] = this.baseService.getUserType();
            for (let contextMenuKey in field.config.buttonMenu) {
                var contextMenu = field.config.buttonMenu[contextMenuKey];
                if (contextMenu.conditions != undefined && contextMenu.conditions.length > 0) {
                    for (let singleCondition of contextMenu.conditions) {
                        this._allowedContextMenu[index][contextMenuKey] = false;//default hide
                        delete result[contextMenuKey];
                        /************* CHECKING APPLICATION  ******************/
                        if (singleCondition.application != undefined && singleCondition.application) {
                            if (Array.isArray(singleCondition.application)) {
                                if (singleCondition.application.indexOf(this.baseService.getAppName()) == -1) {//application not present in array no need further processing
                                    this._allowedContextMenu[index][contextMenuKey] = false;
                                    break;//don't need to go further

                                }
                            } else {
                                if (singleCondition.application != this.baseService.getAppName()) {
                                    this._allowedContextMenu[index][contextMenuKey] = false;
                                    break;//don't need to go further
                                }
                            }
                        }
                        /************* CHECKING APPLICATION  ******************/

                        /************* CHECKING ROLE  ******************/
                        if (singleCondition.user_type != undefined && singleCondition.user_type) {
                            if (Array.isArray(singleCondition.user_type)) {
                                if (singleCondition.user_type.indexOf(this.baseService.getUserType()) == -1) {//application not present in array no need further processing
                                    this._allowedContextMenu[index][contextMenuKey] = false;
                                    break;//don't need to go further

                                }
                            } else {
                                if (singleCondition.user_type != this.baseService.getUserType()) {
                                    this._allowedContextMenu[index][contextMenuKey] = false;
                                    break;//don't need to go further
                                }
                            }
                        }
                        /************* CHECKING ROLE  ******************/

                        /************* CHECKING EXPRESSION  ******************/
                        if (singleCondition.expression != undefined && singleCondition.expression) {
                            try {
                                if (!eval(singleCondition.expression)) {
                                    this._allowedContextMenu[index][contextMenuKey] = false;
                                    break;//don't need to go further
                                }
                            } catch (e) {
                                console.error(e);
                                this._allowedContextMenu[index][contextMenuKey] = false;
                                break;//don't need to go further
                            }

                        }
                        /************* CHECKING EXPRESSION  ******************/
                        result[contextMenuKey] = true;
                        this._allowedContextMenu[index][contextMenuKey] = true;//if the code reached till here it means are condition are passed and we could the menu
                    }
                } else {
                    result[contextMenuKey] = true;
                }
            }
            finalResult = Object.keys(result).length > 0;

        } else {
            finalResult = false;
        }
        if (field)
            field.finalResult = finalResult;
        return finalResult;
    }
    checkboxItemEmit() {
        this.checkBoxDataEmit.emit(this.selectedItems);
    }
    expandColapseTable(event?: any) {
        //console.log("naman");
        let a = this.elementRef.nativeElement.getElementsByClassName('column-expand');
        //console.log(a[0].classList.value);
        let b = this.elementRef.nativeElement.getElementsByClassName('base-table');
        let c = this.elementRef.nativeElement.getElementsByClassName('table-expand-icn');
        var classes = b[0].classList.value;
        //console.log(classes);
        if (classes.includes("table-expand")) {
            //console.log("class already there");
            a[0].classList.remove("active");
            b[0].classList.remove("table-expand");
            c[0].classList.remove("fa-compress");
        }
        else {
            //console.log("class needs to be added");
            a[0].classList.add("active");
            b[0].classList.add("table-expand");
            c[0].classList.add("fa-compress");
        }
    }

    clickOnLink(item, field) {
        var fieldAction = field.action_config.action;
        var newobj = { fieldAction, item, title: field.action_config.title, size: field.action_config.size };
        if (fieldAction == "text") {
            this.baseService.modalService.dialogService.open(PopUpOverGridWithControlsComponent, newobj).afterClosed.subscribe(data => { }, err => { })
        }
        // if (fieldAction == 'templateInterceptor') {
        //     field.action_config.datasource.args = field.action_config.datasource.args ? this.baseService.buildDyanamicStr(field.action_config.datasource.args, { data: item }) : '';
        //     this.openTemplIntersep(item, {
        //         "templateInterceptor": {
        //             "datasource": field.action_config.datasource
        //         }
        //     }, (field.action_config.config ? field.action_config.config : undefined));
        // }
        if (field.linkName != undefined && field.linkName != '' && field.action_config.action != "text" && fieldAction != 'templateInterceptor') {
            // added for banner print
            if (this.config != undefined && this.config.showBanner != undefined && this.config.showBanner && field && typeof field == 'object') {
                field = { ...field, ...{ showBanner: this.config.showBanner } }
            }
            const isTable = field?.action_config?.type === 'table';
            const title = isTable ? field?.action_config?.header || '' : '';
            this.baseService.modalService.dialogService.open(PopUpOverGridWithControlsComponent, { title, size: DialogModalSize.Lg, data: item, popupConfig: field.action_config.type == 'table' ? field : '' ,config:field}).afterClosed.subscribe(data => {
                console.log('data', data)
                if (data && data.bindGrid && data.bindGrid == true)
                    this.emitDefaultFilter();
            }, err => {
                console.log('err', err)
            })
        }
        else {
            this.commonService?.documentPopup({ item: item, field: field })
            // this.emitCustomLink.emit({ item: item, field: field });
        }
    }

    getDataFn(data: any) {
        //this.page = 1; // commented because it was overriding the value provided by data grid config
        if (data.type == "form" && data.obj && data.obj.form != undefined) {
            this.filterFormGroup = data.obj.form;

            if (this.config != undefined && this.config.filterData != undefined && Object.keys(this.config.filterData).length) {
                for (let key in this.config.filterData) {
                    if (this.filterFormGroup.controls != undefined && this.filterFormGroup.controls[key] != undefined) {
                        this.filterFormGroup.controls[key].setValue(this.config.filterData[key]);
                    }
                }
            }
        } else if (data.type == "mapping" && data.obj && data.obj.form != undefined) {
            this.filterFormMapping = data.obj.form;
        }
        else if (data.type == "default_filter" && data.obj && data.obj.form != undefined) {
            if (this.config && this.config.default_sorted) {
                this.applyDefaultSorting(data.obj.form)
            }
            else {
                //this.configValues.emit({ 'changePage':0});
                this.setDataForFilter(data.obj.form);
                // if(this.config.dynamic_filter == undefined){
                //     this.setDataForFilter(data.obj.form);
                // }else{
                //     this.setDataForFilter(data.obj.form);
                //     // this.bindGrid.emit(data.obj.form);
                // }
            }
        } else if (data.type == 'filter_save') {
            this.saveFilterData(data.obj, data.forUserPref != undefined ? data.forUserPref : false);
        } else if (data.type == 'changePage') {
            this.configValues.emit({ 'changePage': data.obj.page });
        }
    }
    getHt(id) {
        let height = document.getElementById(id).offsetHeight;
    }

    saveFilterData(obj, forUserPref?) {
        this.getTableConfig((all_resource_data) => {
            var saveData = {};
            var key = this.config.saveKey;
            if (forUserPref) {
                if (all_resource_data["account__" + key] != undefined) {
                    saveData = all_resource_data["account__" + key];
                }
            } else {
                saveData = (all_resource_data) ? all_resource_data : {};
            }

            saveData["filter__"] = (saveData["filter__"] == undefined) ? [] : saveData["filter__"];
            var found = false;
            let index = 0
            if (obj.key != undefined) {
                for (index = 0; index < saveData["filter__"].length; index++) {
                    var filter = saveData["filter__"][index];
                    if (filter.key == obj.key) {
                        found = true;
                        break;
                    }
                }
            }
            if (found) {
                saveData["filter__"][index] = obj;
            } else {
                if (forUserPref) {
                    saveData["filter__"] = [obj]; //not pushing because it will be merged with latest data in line no 1191 in saveTableConfigData function , if we merge here duplicate filter will be created earlier it was working because of a bug where user data was coming and after it was being removed so effectively only one data was being pushed from here.
                } else {
                    saveData["filter__"].push(obj);
                }

            }
            this.saveTableConfigData(saveData, () => {
                this.getSavedFilter();
            }, forUserPref);
        }, forUserPref);
    }

    createCustomCard() {
        if (this.config.card_selector != undefined) {
            if (this.items != null) {
                // clear old custom component if exists
                //  this.customComponent.toArray().forEach(container => {
                //     container.clear();
                // });
                for (let i = 0; i < this.customComponent.toArray().length; i++) {
                    this.baseService.createComponent(this.config.card_selector, this.customComponent.toArray()[i], (response: any) => {
                        response.instance.item = this.items[i];

                        if (this.config.card_resource != undefined) {
                            response.instance.card_resource = this.utilService.isOnlyMobile() && this.config.mobile_card_resource ? this.config.mobile_card_resource : this.config.card_resource;
                        }

                        if (this.config.mobile_card_resource != undefined) {
                            response.instance.card_resource = this.utilService.isOnlyMobile() && this.config.mobile_card_resource ? this.config.mobile_card_resource : this.config.card_resource;
                        }

                        if (this.config.rowClick != undefined) {
                            response.instance.rowClick = this.config.rowClick;
                        }
                        response.instance.index = i;
                        if (this.config.uiConfigData != undefined) {
                            response.instance.uiConfigData = this.config.uiConfigData;
                        }

                        if (response.changeDetectorRef != undefined) {
                            response.changeDetectorRef.detectChanges();
                        }

                        response.instance.action.subscribe((message: any) => {
                            console.log('Parent received:', message);
                            this.clickRow(this.fields, message.item);
                        });
                    });
                }
            }
        }
    }
    checkGridButtonCondition(button, item) {
        if (button.conditions == undefined || !button.conditions)
            return true;
        else {
            for (let singleCondition of button.conditions) {
                if (singleCondition.expression != undefined && singleCondition.expression) {
                    try {
                        if (!eval(singleCondition.expression)) {
                            return false;
                        }
                    } catch (e) {
                        return false;
                        console.error(e);
                    }
                }
                else
                    return false;
            }
            return true;
        }
    }
    showSelectedItems() {
        if (this.bulkActionsConfig && this.bulkActionsConfig.show_popup == undefined) {
            let fields_ = JSON.parse(JSON.stringify(this.fields));
            let popObj = {
                data: { 'resource': this.selectedItems },
                action: "LIST",
                fields: fields_,
                title: 'View Selected Items',
                size: DialogModalSize.Lg,
                btn: this.bulkActionsConfig.actions,
                config: {
                    "viewAll": false,
                    "hideSearchBox": true,
                    "allowPagination": false,
                    "customButtonsAllowed": false
                }
            }
            const index = fields_.findIndex(x => x.config && x.config.buttonMenu)
            if (index > -1) {
                fields_.splice(index, 1);
            }
            this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(
                response => {
                    if (response) {
                        this.onBulkActionClicked(response)
                    }
                });
        }
    }

    showAuditLogs() {
        let popObj = {
            data: { 'resource_filter': this.config.resource, 'resource': "audit_log_new" },
            title: 'Logs',
            size: DialogModalSize.Lg
        };

        this.config.popupModel = this.dialogService.open(AuditLogComponent, popObj);
        this.config.popupModel.afterClosed.subscribe(response => {
            delete this.config.popupModel;
        });
    }
    ngAfterViewInit() {
        if (
            this.config && this.config.defaultTableExpand &&
            this.config.defaultTableExpand === true &&
            !this.tableExpandedOnce
        ) {
            setTimeout(() => {
                this.expandColapseTable();
                this.tableExpandedOnce = true;
            });
        }
    }
    // ngAfterViewChecked(){
    //         if(document.getElementsByClassName('base-table')[0])
    //         this.width = document.getElementsByClassName('base-table')[0].getBoundingClientRect().width
    // }
    // simulateScroll(id,e){
    //     document.getElementById(id).scrollLeft = e.target['scrollLeft']
    // }
    showPrintAction(id) {
        this.showPrint = !this.showPrint;
        if (this.showPrint && document.getElementById(id) != undefined && document.getElementById(id) && !document.getElementById(id).classList.contains('show')) {
            document.getElementById(id).classList.add("show");
        } else if (document.getElementById(id) != undefined && document.getElementById(id) && document.getElementById(id).classList.contains('show')) {
            document.getElementById(id).classList.remove("show");
        }
    }
    showdownloadAction(id) {
        this.showDownload = !this.showDownload;
        if (this.showDownload && document.getElementById(id) != undefined && document.getElementById(id) && !document.getElementById(id).classList.contains('show')) {
            document.getElementById(id).classList.add("show");
        } else if (document.getElementById(id) != undefined && document.getElementById(id) && document.getElementById(id).classList.contains('show')) {
            document.getElementById(id).classList.remove("show");
        }
    }

    configureGrid() {
        this.configValues.emit({ configureGrid: { 'context': "grid" } });
    }
    viewHelp() {
        if (this.config.resource != undefined) {
            this.dialogService.open(HtmlViewerComponent, { data: { resource_name: this.config.resource, summary: this.config.amountResource && this.config.amountResource.datasource ? true : false } }).afterClosed.subscribe(
                response => {

                }
            );
        } else {
            console.error("resource not found for help");
            this.alerts.error("hpnf")
        }

    }

    showArchivePolicy() {
        if (this.config.archiveConfig) {
            if (this.config.archiveConfig.catalogue_code != undefined) {
                this.checkCatalagueConfigExists(this.config, (resourceDef) => {
                    this.toggleArchivePolicy();
                })
            } else {
                this.toggleArchivePolicy();
            }
        }
    }

    toggleArchivePolicy() {
        if (this.config.archiveConfig.list != undefined && this.config.archiveConfig.list.length > 0) {
            if (this.config.archiveConfig.open == undefined) {
                this.config.archiveConfig.open = true;
            } else {
                this.config.archiveConfig.open = !this.config.archiveConfig.open;
            }
        }

    }

    checkCatalagueConfigExists(config, cb) {
        this.preferenceService.checkCatalagueConfigExists(config, (respObj) => {
            if (respObj) {
                this.configValues.emit(respObj);
            }
            cb(config);
        })
    }

    setArchivePolicy(archiveConfig) {
        this.config.archiveConfig.selected = archiveConfig;
        this.configValues.emit({ 'archiveConfig': archiveConfig });
    }

    // openrecognition(){
    //     let obj = { data: {"send_base64_data":true}, title: 'Face Recognition', size: DialogModalSize.Sm, className: "modal-l"};
    //     this.dialogService.open(ClickPhotoComponent, obj).afterClosed.subscribe(
    //       response => {
    //         if (response) {
    //           let headers = new HttpHeaders();
    //             headers = headers.set('access_token', '8e1ca505-12c3-4a08-8ee3-96ded25f3664');

    //             var resource = {
    //                "data":response
    //               }

    //             this.baseService.action(resource,"FACE_MATCH","patient-registration","face_match").subscribe((res) => {
    //                 console.log(res);
    //             });

    //         }
    //       }
    //     );

    //     }


    viewDoc(item, field) {
        if (field.type == 'String') {
            let arr = item[field.name].split('.');
            if (arr[arr.length - 1] == 'pdf') {
                this.showDocument(item, field);
            } else {
                this.smartModalService.open(ImageViewerComponent, { data: { src: [this.baseService.getApiEndpoint("dms") + (field.document_type ? field.document_type : 'emrImage') + '/image-response-entity?args=id:' + item[field.fieldName] + '&application=dms'], fileData: [{ name: 'img' }] } }, item[field.name], ModalSize.Xl).pipe(take(1)).subscribe(data => { }, err => { });
            }
        } else {
            if (field.type == 'array' && item[field.fieldName] && Array.isArray(item[field.fieldName]) && item[field.fieldName].length > 0) {
                const hasAnnotated = item[field.fieldName].some(el => el.annotatedDocument != undefined);
                if (hasAnnotated) {
                    let srcs = []; let document_name = []; let file_data = [];
                    item[field.fieldName].forEach(element => {
                        if(element.annotatedDocument != undefined){
                            srcs.push(this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + element.annotatedDocument + '&application=dms')
                            document_name.push(element.documentName);
                            file_data.push({ name: 'img' });
                        }
                    });
                    this.smartModalService.open(ImageViewerComponent, { data: { src: srcs, fileData: file_data } }, document_name, ModalSize.Xl).pipe(take(1)).subscribe();
                } else {
                    const ids = item[field.fieldName].map(el => el);
                    const document_name = item[field.fieldName].map(el => el);
                    this.loader.showSpinner();
                    this.baseService.fetchFilesAsBlobUrls(ids, field.document_type || 'emrImage')
                        .then(files => {
                            this.smartModalService.open(ImageViewerComponent, { data: { blobItems: files } }, document_name, ModalSize.Xl).pipe(take(1)).subscribe();
                        })
                        .finally(() => {
                            this.loader.hideSpinner();
                        });
                }
            } else
                this.smartModalService.open(ImageViewerComponent, { data: { src: [this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + item[field.fieldName][0].annotatedDocument + '&application=dms'], fileData: [{ name: 'img' }] } }, item[field.fieldName][0].documentName, ModalSize.Xl).pipe(take(1)).subscribe(data => { }, err => { });
        }
    }

    setbulkExtrakeys(action, val, obj) {
        try {
            if (action.bulkExtrakeys != undefined && action.bulkExtrakeys.length != undefined && action.bulkExtrakeys.length > 0) {
                for (let key of action.bulkExtrakeys) {
                    let val_ = this.getId(obj.val, key.getterValue);
                    val[key.getterKey] = val_.split(',');
                }
            }
        } catch (error) {

        }
    }

    redirect(info) {
        this.router.navigate([info.url], { queryParams: { returnUrl: this.router.url, key: info.base, uhId: this.config.f__search } });
    }

    openMasterUpload(masterUpload = this.config.master_upload) {
        this.loader.showSpinner();
        let objRefer = {
            "application": "data-onboarding",
            "resource": "master_upload_checklist",
            "query_id": "GET_CHECKLIST_FOR_TEMPLATE",
            "args": "resource_name:" + masterUpload.resource
        };
        this.baseService.getByDataSource(objRefer).subscribe((res) => {
            this.loader.hideSpinner();
            if (res.errCode == 0 && res.resource != undefined && res.resource.length > 0) {
                this.storageService.setSessionStorageData("currentData", res.resource[0], () => {
                    console.log("saved");
                    this.router.navigateByUrl('data-onboarding/upload_file?key=' + res.resource[0].id);
                });
            }
        }, error => {
            this.loader.hideSpinner();
        })

    }

    isLimitSelectionReached(isChecked: any) {
        const limit = this.bulkActionsConfig?.actions?.find(a => a?.allow_selection != null)?.allow_selection ?? null;
        if (isChecked !== true) return this.limitErrorShown = false;   // reset flag 
        if (!limit) return false;                              // no limit return 
        if (this.selectedItems.length >= limit) {              // limit reached
            if (!this.limitErrorShown) {
                this.alerts.error(`Only ${limit} items are allowed`);
                this.limitErrorShown = true;
            }
            return true;
        }
        return false;
    }


    switchView(event) { // table --> card or card --> table  
        this.editEllipseClick.emit({ 'actionType': { action: event, action_name: this.config.activeField == 'table' ? 'tile' : 'table' } });
    }
    copyGridCellValue(event: Event, item: any, field: any): void {
        event.stopPropagation();

        let valueToCopy: string = '';
        if (field && field.name) {
            if (item[field.name] !== undefined && item[field.name] !== null) {
                valueToCopy = String(item[field.name]);
            }
        }

        this.fallbackCopyTextToClipboard(valueToCopy);
        this.copiedFieldId = item['id'];

        setTimeout(() => {
            this.copiedFieldId = null;
        }, 500);
    }
    fallbackCopyTextToClipboard(text: string): void {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.removeChild(textarea);
    }

    // recent patient history in emr click  method
    recentPatientHistory() {
        this.gridPopupClicked.emit();
    }

    // gridPlotTimeToLocalStorage(plottingTime?: string): void {
    //     this.storageService.getSessionStorageDataSimple('gridPlotTime', (data: any) => {
    //         const obj = typeof data === 'string' ? JSON.parse(data) : (data || {});
    //         obj[this.config.resource] = plottingTime;
    //         this.storageService.setSessionStorageData('gridPlotTime', obj, () => { });
    //     });
    // }

    manupulateArgs(data, args) {
        let tempArgs = JSON.parse(JSON.stringify('!!!' + args + '!!!'));
        let finalargs = [];
        for (let val of data) {
            let strngVal = this.baseService.buildDyanamicStr(tempArgs, { 'data': val });
            finalargs.push(strngVal);
        }
        return args + ":" + finalargs.join('=');
    }


    translateLabel(key: string): string {
        if (!key) return '';

        if (this.translationCache[key]) {
            return this.translationCache[key];
        }

        if (!this.loadingTranslations.has(key)) {
            this.loadingTranslations.add(key);

            this.translateService.translateSync(key).then(res => {
                this.translationCache[key] = res;
                this.loadingTranslations.delete(key);
            });
        }

        return key; // temporary fallback
    }
    isContextMenuOpen(index: number): boolean {
        return this.activeContextRow === index;
    }

    toggleContextMenu(iRow: number, event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.activeContextRow = this.activeContextRow === iRow ? -1 : iRow;
    }

    activeSettingsHeader: string | null = null;
    isSettingsMenuOpen(fieldName: string): boolean {
        return this.activeSettingsHeader !== null && this.activeSettingsHeader === fieldName;
    }

    toggleSettingsMenu(fieldName: string, event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.activeSettingsHeader = this.activeSettingsHeader === fieldName ? null : fieldName;
    }

    @HostListener('document:click')
    closeContextMenu() {
        if (this.activeContextRow !== -1) {
            this.activeContextRow = -1;
        }
        if (this.activeSettingsHeader !== null) {
            this.activeSettingsHeader = null;
        }
    }

    performBulkActionWithoutCheckbox() {
        this.baseService.getResourceDef(this.config.resource, (resDef) => {
            if (resDef?.config?.decorator) {
                if (!this.decoratorInstance)
                    this.decoratorInstance = this.baseService.initDecorator(resDef.config.decorator, this.route, this.injector);

                if (this.decoratorInstance?.performBulkActionWithoutCheckbox && typeof this.decoratorInstance.performBulkActionWithoutCheckbox === 'function') {
                    this.decoratorInstance.performBulkActionWithoutCheckbox();
                } else {
                    console.warn('performBulkActionWithoutCheckbox method not defined in decorator for resource:', this.config.resource);
                }
            } else {
                console.warn('Decorator not defined for resource:', this.config.resource);
            }
        });
    }

    // gridPlotTimeToLocalStorage(plottingTime?: string): void {
    //     this.storageService.getSessionStorageDataSimple('gridPlotTime', (data: any) => {
    //         const obj = typeof data === 'string' ? JSON.parse(data) : (data || {});
    //         obj[this.config.resource] = plottingTime;
    //         this.storageService.setSessionStorageData('gridPlotTime', obj, () => { });
    //     });
    // }
}

// export class ActionClickEvent {

//     constructor(public action: string, public item: any) { }
// }

export class BulkActionClickEvent {

    constructor(public action: string, public items: any[], public anyItem?: any, public selectedIndices?: boolean[], public projectionkeys?: any, public $event?: any) {
    }
}
